var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/web3Service.ts
import { ethers as ethers6 } from "ethers";

// src/utils.ts
import { ethers } from "ethers";
var utils_default = {
  toWei: (value, units) => ethers.utils.parseUnits(value, units),
  toDecimal: (value, decimals) => ethers.utils.parseUnits(value, decimals),
  hexlify: ethers.utils.hexlify,
  hexStripZeros: ethers.utils.hexStripZeros,
  bigNumberify: ethers.BigNumber.from,
  hexToNumberString: (num) => ethers.utils.formatUnits(ethers.BigNumber.from(num), "wei").replace(".0", ""),
  toChecksumAddress: ethers.utils.getAddress,
  fromWei: (num, units) => {
    return ethers.utils.formatUnits(ethers.BigNumber.from(num), units).replace(/\.0$/, "");
  },
  fromDecimal: (num, decimals) => {
    return ethers.utils.formatUnits(ethers.BigNumber.from(num), decimals).replace(/\.0$/, "");
  },
  isInfiniteKeys: (value) => {
    return ethers.BigNumber.from(value).eq(ethers.constants.MaxUint256);
  },
  isInfiniteDuration: (value) => {
    return ethers.BigNumber.from(value).eq(ethers.constants.MaxUint256);
  },
  toNumber: (value) => {
    return ethers.BigNumber.from(value).toNumber();
  },
  toRpcResultNumber: (value) => {
    const num = ethers.utils.hexlify(ethers.BigNumber.from(value));
    return ethers.utils.hexZeroPad(num, 32);
  },
  toRpcResultString: (str) => {
    return str;
  },
  utf8ToHex: (str) => ethers.utils.hexlify(str.length ? ethers.utils.toUtf8Bytes(str) : 0),
  sha3: ethers.utils.keccak256,
  verifyMessage: ethers.utils.verifyMessage
};
var FetchError = class extends Error {
  constructor({
    message,
    response,
    data
  }) {
    super(message);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }
    this.name = "FetchError";
    this.response = response;
    this.data = data || { message };
  }
};

// src/unlockService.ts
import { ethers as ethers5 } from "ethers";

// src/abis.ts
var abis = {
  "PublicLock": {
    "v4": {
      "contractName": "PublicLock",
      "abi": [
        "function supportsInterface(bytes4 interfaceId) constant view returns (bool)",
        "function owners(uint256) constant view returns (address)",
        "function name() constant view returns (string)",
        "function getApproved(uint256 _tokenId) constant view returns (address)",
        "function approve(address _approved,uint256 _tokenId) payable",
        "function updateBeneficiary(address _beneficiary)",
        "function refundPenaltyDenominator() constant view returns (uint256)",
        "function refundPenaltyNumerator() constant view returns (uint256)",
        "function unlockProtocol() constant view returns (address)",
        "function getOwnersByPage(uint256 _page,uint256 _pageSize) constant view returns (address[])",
        "function keyPrice() constant view returns (uint256)",
        "function expirationDuration() constant view returns (uint256)",
        "function onERC721Received(address,address,uint256,bytes) returns (bytes4)",
        "function totalSupply() constant view returns (uint256)",
        "function updateKeyPrice(uint256 _keyPrice)",
        "function cancelAndRefund()",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId) payable",
        "function withdraw(uint256 _amount)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function beneficiary() constant view returns (address)",
        "function updateRefundPenalty(uint256 _refundPenaltyNumerator,uint256 _refundPenaltyDenominator)",
        "function numberOfKeysSold() constant view returns (uint256)",
        "function updateTransferFee(uint256 _transferFeeNumerator,uint256 _transferFeeDenominator)",
        "function isAlive() constant view returns (bool)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId) payable",
        "function strConcat(string _a,string _b,string _c,string _d) constant pure returns (string _concatenatedString)",
        "function keyOwnerToNonce(address) constant view returns (uint256)",
        "function uint2Str(uint256 _i) constant pure returns (string _uintAsString)",
        "function getCancelAndRefundValueFor(address _owner) constant view returns (uint256 refund)",
        "function updateLockName(string _lockName)",
        "function address2Str(address _addr) constant pure returns (string)",
        "function incrementNonce()",
        "function ownerOf(uint256 _tokenId) constant view returns (address)",
        "function getHasValidKey(address _owner) constant view returns (bool)",
        "function balanceOf(address _owner) constant view returns (uint256)",
        "function purchaseForFrom(address _recipient,address _referrer) payable",
        "function renounceOwnership()",
        "function maxNumberOfKeys() constant view returns (uint256)",
        "function updateLockSymbol(string _lockSymbol)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps)",
        "function getTransferFee(address _owner) constant view returns (uint256)",
        "function getCancelAndRefundApprovalHash(address _keyOwner,address _txSender) constant view returns (bytes32 approvalHash)",
        "function owner() constant view returns (address)",
        "function isOwner() constant view returns (bool)",
        "function transferFeeNumerator() constant view returns (uint256)",
        "function numberOfOwners() constant view returns (uint256)",
        "function symbol() constant view returns (string)",
        "function getTokenIdFor(address _account) constant view returns (uint256)",
        "function isKeyOwner(uint256 _tokenId,address _owner) constant view returns (bool)",
        "function grantKey(address _recipient,uint256 _expirationTimestamp)",
        "function tokenAddress() constant view returns (address)",
        "function expireKeyFor(address _owner)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function destroyLock()",
        "function keyExpirationTimestampFor(address _owner) constant view returns (uint256 timestamp)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data) payable",
        "function cancelAndRefundFor(address _keyOwner,bytes _signature)",
        "function disableLock()",
        "function initialize(address sender)",
        "function tokenURI(uint256 _tokenId) constant view returns (string)",
        "function transferFeeDenominator() constant view returns (uint256)",
        "function isApprovedForAll(address _owner,address _operator) constant view returns (bool)",
        "function transferOwnership(address newOwner)",
        "function purchaseFor(address _recipient) payable",
        "function getBalance(address _account) constant view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256 _expirationTimestamp)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event RefundPenaltyChanged (uint256 oldRefundPenaltyNumerator,uint256 oldRefundPenaltyDenominator,uint256 refundPenaltyNumerator,uint256 refundPenaltyDenominator)",
        "event TransferFeeChanged (uint256 oldTransferFeeNumerator,uint256 oldTransferFeeDenominator,uint256 transferFeeNumerator,uint256 transferFeeDenominator)",
        "event NewLockSymbol (string symbol)",
        "event ExpireKey (uint256 tokenId)",
        "event PriceChanged (uint256 oldKeyPrice,uint256 keyPrice)",
        "event Withdrawal (address indexed sender,address indexed beneficiary,uint256 amount)",
        "event Destroy (uint256 balance,address indexed owner)",
        "event Disable ()",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event Transfer (address indexed _from,address indexed _to,uint256 indexed _tokenId)",
        "event Approval (address indexed _owner,address indexed _approved,uint256 indexed _tokenId)",
        "event ApprovalForAll (address indexed _owner,address indexed _operator,bool _approved)",
        "function publicLockVersion() constant pure returns (uint16)"
      ],
      "bytecodeHash": "0x0d7ea1df12ab87024edd7add411416ee61a3f09cf41a0b6aa5499e1bc4277651"
    },
    "v6": {
      "contractName": "PublicLock",
      "abi": [
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event Destroy (uint256 balance,address indexed owner)",
        "event Disable ()",
        "event ExpireKey (uint256 indexed tokenId)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event NonceChanged (address indexed keyOwner,uint256 nextAvailableNonce)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event TimestampChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function BASIS_POINTS_DEN() constant view returns (uint256)",
        "function CANCEL_TYPEHASH() constant view returns (bytes32)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function balanceOf(address _owner) constant view returns (uint256)",
        "function beneficiary() constant view returns (address)",
        "function cancelAndRefund()",
        "function cancelAndRefundFor(address _keyOwner,uint8 _v,bytes32 _r,bytes32 _s)",
        "function destroyLock()",
        "function disableLock()",
        "function erc1820() constant view returns (address)",
        "function expirationDuration() constant view returns (uint256)",
        "function expireKeyFor(address _owner)",
        "function freeTrialLength() constant view returns (uint256)",
        "function fullRefund(address _keyOwner,uint256 amount)",
        "function getApproved(uint256 _tokenId) constant view returns (address)",
        "function getBalance(address _tokenAddress,address _account) constant view returns (uint256)",
        "function getCancelAndRefundApprovalHash(address _keyOwner,address _txSender) constant view returns (bytes32 approvalHash)",
        "function getCancelAndRefundValueFor(address _owner) constant view returns (uint256 refund)",
        "function getHasValidKey(address _owner) constant view returns (bool)",
        "function getOwnersByPage(uint256 _page,uint256 _pageSize) constant view returns (address[])",
        "function getTokenIdFor(address _account) constant view returns (uint256)",
        "function getTransferFee(address _owner,uint256 _time) constant view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps)",
        "function invalidateOffchainApproval(uint256 _nextAvailableNonce)",
        "function isAlive() constant view returns (bool)",
        "function isApprovedForAll(address _owner,address _operator) constant view returns (bool)",
        "function isKeyOwner(uint256 _tokenId,address _owner) constant view returns (bool)",
        "function isLockManager(address account) constant view returns (bool)",
        "function isOwner() constant view returns (bool)",
        "function keyCancelInterfaceId() constant view returns (bytes32)",
        "function keyExpirationTimestampFor(address _owner) constant view returns (uint256 timestamp)",
        "function keyOwnerToNonce(address) constant view returns (uint256)",
        "function keyPrice() constant view returns (uint256)",
        "function keySoldInterfaceId() constant view returns (bytes32)",
        "function maxNumberOfKeys() constant view returns (uint256)",
        "function name() constant view returns (string)",
        "function numberOfOwners() constant view returns (uint256)",
        "function owner() constant view returns (address)",
        "function ownerOf(uint256 _tokenId) constant view returns (address)",
        "function owners(uint256) constant view returns (address)",
        "function publicLockVersion() constant pure returns (uint256)",
        "function purchase(uint256 _value,address _recipient,address _referrer,bytes _data) payable",
        "function refundPenaltyBasisPoints() constant view returns (uint256)",
        "function renounceLockManager()",
        "function renounceOwnership()",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function shareKey(address _to,uint256 _tokenId,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) constant view returns (bool)",
        "function symbol() constant view returns (string)",
        "function tokenAddress() constant view returns (address)",
        "function tokenByIndex(uint256 _index) constant view returns (uint256)",
        "function tokenOfOwnerByIndex(address _owner,uint256 _index) constant view returns (uint256)",
        "function tokenURI(uint256 _tokenId) constant view returns (string)",
        "function totalSupply() constant view returns (uint256)",
        "function transferFeeBasisPoints() constant view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function transferOwnership(address newOwner)",
        "function unlockProtocol() constant view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)",
        "function initialize(address _owner,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function initialize()",
        "function initialize(address sender)"
      ],
      "bytecodeHash": "0x39260d0911736892b9a71a2c6b5fc69a98c58d297f8c4ca0bd7ee96c54244c69"
    },
    "v7": {
      "contractName": "PublicLock",
      "abi": [
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event Disable ()",
        "event ExpirationChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event ExpireKey (uint256 indexed tokenId)",
        "event KeyGranterAdded (address indexed account)",
        "event KeyGranterRemoved (address indexed account)",
        "event KeyManagerChanged (uint256 indexed _tokenId,address indexed _newManager)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event NonceChanged (address indexed keyManager,uint256 nextAvailableNonce)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event RenewKeyPurchase (address indexed owner,uint256 newExpiration)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function addKeyGranter(address account)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function balanceOf(address _keyOwner) constant view returns (uint256)",
        "function beneficiary() constant view returns (address)",
        "function cancelAndRefund(uint256 _tokenId)",
        "function cancelAndRefundFor(address _keyManager,uint8 _v,bytes32 _r,bytes32 _s,uint256 _tokenId)",
        "function disableLock()",
        "function expirationDuration() constant view returns (uint256)",
        "function expireAndRefundFor(address _keyOwner,uint256 amount)",
        "function freeTrialLength() constant view returns (uint256)",
        "function getApproved(uint256 _tokenId) constant view returns (address)",
        "function getBalance(address _tokenAddress,address _account) constant view returns (uint256)",
        "function getCancelAndRefundApprovalHash(address _keyManager,address _txSender) constant view returns (bytes32 approvalHash)",
        "function getCancelAndRefundValueFor(address _keyOwner) constant view returns (uint256 refund)",
        "function getHasValidKey(address _keyOwner) constant view returns (bool)",
        "function getOwnersByPage(uint256 _page,uint256 _pageSize) constant view returns (address[])",
        "function getTokenIdFor(address _account) constant view returns (uint256)",
        "function getTransferFee(address _keyOwner,uint256 _time) constant view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps,address[] _keyManagers)",
        "function invalidateOffchainApproval(uint256 _nextAvailableNonce)",
        "function isAlive() constant view returns (bool)",
        "function isApprovedForAll(address _owner,address _operator) constant view returns (bool)",
        "function isKeyGranter(address account) constant view returns (bool)",
        "function isKeyOwner(uint256 _tokenId,address _keyOwner) constant view returns (bool)",
        "function isLockManager(address account) constant view returns (bool)",
        "function keyExpirationTimestampFor(address _keyOwner) constant view returns (uint256)",
        "function keyManagerOf(uint256) constant view returns (address)",
        "function keyManagerToNonce(address) constant view returns (uint256)",
        "function keyPrice() constant view returns (uint256)",
        "function maxNumberOfKeys() constant view returns (uint256)",
        "function name() constant view returns (string)",
        "function numberOfOwners() constant view returns (uint256)",
        "function onKeyCancelHook() constant view returns (address)",
        "function onKeyPurchaseHook() constant view returns (address)",
        "function ownerOf(uint256 _tokenId) constant view returns (address)",
        "function owners(uint256) constant view returns (address)",
        "function publicLockVersion() constant pure returns (uint256)",
        "function purchase(uint256 _value,address _recipient,address _referrer,bytes _data) payable",
        "function purchasePriceFor(address _recipient,address _referrer,bytes _data) constant view returns (uint256 minKeyPrice)",
        "function refundPenaltyBasisPoints() constant view returns (uint256)",
        "function renounceLockManager()",
        "function revokeKeyGranter(address _granter)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function setEventHooks(address _onKeyPurchaseHook,address _onKeyCancelHook)",
        "function setKeyManagerOf(uint256 _tokenId,address _keyManager)",
        "function shareKey(address _to,uint256 _tokenId,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) constant view returns (bool)",
        "function symbol() constant view returns (string)",
        "function tokenAddress() constant view returns (address)",
        "function tokenByIndex(uint256 _index) constant view returns (uint256)",
        "function tokenOfOwnerByIndex(address _keyOwner,uint256 _index) constant view returns (uint256)",
        "function tokenURI(uint256 _tokenId) constant view returns (string)",
        "function totalSupply() constant view returns (uint256)",
        "function transferFeeBasisPoints() constant view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function unlockProtocol() constant view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)",
        "function initialize(address _lockCreator,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function initialize()"
      ],
      "bytecodeHash": "0xd66a672853995b93eff7fc1ea6eb09bac55fb58da34a8132703844b6b0837c32"
    },
    "v8": {
      "contractName": "PublicLock",
      "abi": [
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event Disable ()",
        "event ExpirationChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event ExpireKey (uint256 indexed tokenId)",
        "event KeyGranterAdded (address indexed account)",
        "event KeyGranterRemoved (address indexed account)",
        "event KeyManagerChanged (uint256 indexed _tokenId,address indexed _newManager)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event NonceChanged (address indexed keyManager,uint256 nextAvailableNonce)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event RenewKeyPurchase (address indexed owner,uint256 newExpiration)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function addKeyGranter(address account)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function approveBeneficiary(address _spender,uint256 _amount) returns (bool)",
        "function balanceOf(address _keyOwner) constant view returns (uint256)",
        "function beneficiary() constant view returns (address)",
        "function cancelAndRefund(uint256 _tokenId)",
        "function cancelAndRefundFor(address _keyManager,uint8 _v,bytes32 _r,bytes32 _s,uint256 _tokenId)",
        "function disableLock()",
        "function expirationDuration() constant view returns (uint256)",
        "function expireAndRefundFor(address _keyOwner,uint256 amount)",
        "function freeTrialLength() constant view returns (uint256)",
        "function getApproved(uint256 _tokenId) constant view returns (address)",
        "function getBalance(address _tokenAddress,address _account) constant view returns (uint256)",
        "function getCancelAndRefundApprovalHash(address _keyManager,address _txSender) constant view returns (bytes32 approvalHash)",
        "function getCancelAndRefundValueFor(address _keyOwner) constant view returns (uint256 refund)",
        "function getHasValidKey(address _keyOwner) constant view returns (bool)",
        "function getOwnersByPage(uint256 _page,uint256 _pageSize) constant view returns (address[])",
        "function getTokenIdFor(address _account) constant view returns (uint256)",
        "function getTransferFee(address _keyOwner,uint256 _time) constant view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps,address[] _keyManagers)",
        "function invalidateOffchainApproval(uint256 _nextAvailableNonce)",
        "function isAlive() constant view returns (bool)",
        "function isApprovedForAll(address _owner,address _operator) constant view returns (bool)",
        "function isKeyGranter(address account) constant view returns (bool)",
        "function isKeyOwner(uint256 _tokenId,address _keyOwner) constant view returns (bool)",
        "function isLockManager(address account) constant view returns (bool)",
        "function keyExpirationTimestampFor(address _keyOwner) constant view returns (uint256)",
        "function keyManagerOf(uint256) constant view returns (address)",
        "function keyManagerToNonce(address) constant view returns (uint256)",
        "function keyPrice() constant view returns (uint256)",
        "function maxNumberOfKeys() constant view returns (uint256)",
        "function name() constant view returns (string)",
        "function numberOfOwners() constant view returns (uint256)",
        "function onKeyCancelHook() constant view returns (address)",
        "function onKeyPurchaseHook() constant view returns (address)",
        "function ownerOf(uint256 _tokenId) constant view returns (address)",
        "function owners(uint256) constant view returns (address)",
        "function publicLockVersion() constant pure returns (uint256)",
        "function purchase(uint256 _value,address _recipient,address _referrer,bytes _data) payable",
        "function purchasePriceFor(address _recipient,address _referrer,bytes _data) constant view returns (uint256 minKeyPrice)",
        "function refundPenaltyBasisPoints() constant view returns (uint256)",
        "function renounceLockManager()",
        "function revokeKeyGranter(address _granter)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function setEventHooks(address _onKeyPurchaseHook,address _onKeyCancelHook)",
        "function setKeyManagerOf(uint256 _tokenId,address _keyManager)",
        "function shareKey(address _to,uint256 _tokenId,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) constant view returns (bool)",
        "function symbol() constant view returns (string)",
        "function tokenAddress() constant view returns (address)",
        "function tokenByIndex(uint256 _index) constant view returns (uint256)",
        "function tokenOfOwnerByIndex(address _keyOwner,uint256 _index) constant view returns (uint256)",
        "function tokenURI(uint256 _tokenId) constant view returns (string)",
        "function totalSupply() constant view returns (uint256)",
        "function transfer(address _to,uint256 _value) returns (bool success)",
        "function transferFeeBasisPoints() constant view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function unlockProtocol() constant view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)",
        "function initialize(address _lockCreator,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function initialize()"
      ],
      "bytecodeHash": "0x04782fb9f4650646c8db40744d69e4bf68845d1e7164884afb6ba95eb04e1a41"
    },
    "v9": {
      "contractName": "PublicLock",
      "abi": [
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event Disable ()",
        "event ExpirationChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event ExpireKey (uint256 indexed tokenId)",
        "event GasRefunded (address indexed receiver,uint256 refundedAmount,address tokenAddress)",
        "event KeyGranterAdded (address indexed account)",
        "event KeyGranterRemoved (address indexed account)",
        "event KeyManagerChanged (uint256 indexed _tokenId,address indexed _newManager)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event RenewKeyPurchase (address indexed owner,uint256 newExpiration)",
        "event RoleAdminChanged (bytes32 indexed role,bytes32 indexed previousAdminRole,bytes32 indexed newAdminRole)",
        "event RoleGranted (bytes32 indexed role,address indexed account,address indexed sender)",
        "event RoleRevoked (bytes32 indexed role,address indexed account,address indexed sender)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event UnlockCallFailed (address indexed lockAddress,address unlockAddress)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
        "function KEY_GRANTER_ROLE() view returns (bytes32)",
        "function LOCK_MANAGER_ROLE() view returns (bytes32)",
        "function addKeyGranter(address account)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function approveBeneficiary(address _spender,uint256 _amount) returns (bool)",
        "function balanceOf(address _keyOwner) view returns (uint256)",
        "function beneficiary() view returns (address)",
        "function cancelAndRefund(uint256 _tokenId)",
        "function disableLock()",
        "function expirationDuration() view returns (uint256)",
        "function expireAndRefundFor(address _keyOwner,uint256 amount)",
        "function freeTrialLength() view returns (uint256)",
        "function gasRefundValue() view returns (uint256 _refundValue)",
        "function getApproved(uint256 _tokenId) view returns (address)",
        "function getCancelAndRefundValueFor(address _keyOwner) view returns (uint256 refund)",
        "function getHasValidKey(address _keyOwner) view returns (bool isValid)",
        "function getRoleAdmin(bytes32 role) view returns (bytes32)",
        "function getTokenIdFor(address _account) view returns (uint256)",
        "function getTransferFee(address _keyOwner,uint256 _time) view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps,address[] _keyManagers)",
        "function grantRole(bytes32 role,address account)",
        "function hasRole(bytes32 role,address account) view returns (bool)",
        "function initialize(address _lockCreator,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function isAlive() view returns (bool)",
        "function isApprovedForAll(address _owner,address _operator) view returns (bool)",
        "function isKeyGranter(address account) view returns (bool)",
        "function isLockManager(address account) view returns (bool)",
        "function keyExpirationTimestampFor(address _keyOwner) view returns (uint256)",
        "function keyManagerOf(uint256) view returns (address)",
        "function keyPrice() view returns (uint256)",
        "function maxNumberOfKeys() view returns (uint256)",
        "function name() view returns (string)",
        "function numberOfOwners() view returns (uint256)",
        "function onKeyCancelHook() view returns (address)",
        "function onKeyPurchaseHook() view returns (address)",
        "function onTokenURIHook() view returns (address)",
        "function onValidKeyHook() view returns (address)",
        "function ownerOf(uint256 _tokenId) view returns (address)",
        "function publicLockVersion() pure returns (uint16)",
        "function purchase(uint256 _value,address _recipient,address _referrer,address _keyManager,bytes _data) payable",
        "function purchasePriceFor(address _recipient,address _referrer,bytes _data) view returns (uint256 minKeyPrice)",
        "function refundPenaltyBasisPoints() view returns (uint256)",
        "function renounceLockManager()",
        "function renounceRole(bytes32 role,address account)",
        "function revokeKeyGranter(address _granter)",
        "function revokeRole(bytes32 role,address account)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function setEventHooks(address _onKeyPurchaseHook,address _onKeyCancelHook,address _onValidKeyHook,address _onTokenURIHook)",
        "function setExpirationDuration(uint256 _newExpirationDuration)",
        "function setGasRefundValue(uint256 _refundValue)",
        "function setKeyManagerOf(uint256 _tokenId,address _keyManager)",
        "function setMaxNumberOfKeys(uint256 _maxNumberOfKeys)",
        "function shareKey(address _to,uint256 _tokenId,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) view returns (bool)",
        "function symbol() view returns (string)",
        "function tokenAddress() view returns (address)",
        "function tokenByIndex(uint256 _index) view returns (uint256)",
        "function tokenOfOwnerByIndex(address _keyOwner,uint256 _index) view returns (uint256)",
        "function tokenURI(uint256 _tokenId) view returns (string)",
        "function totalSupply() view returns (uint256)",
        "function transfer(address _to,uint256 _value) returns (bool success)",
        "function transferFeeBasisPoints() view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function unlockProtocol() view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)"
      ],
      "bytecodeHash": "0x0cf7c1b77621773fd65811a23143e5e49946d2de75c18934b495940cab871397"
    },
    "v10": {
      "contractName": "PublicLock",
      "abi": [
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event ExpirationChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event ExpireKey (uint256 indexed tokenId)",
        "event GasRefunded (address indexed receiver,uint256 refundedAmount,address tokenAddress)",
        "event KeyExtended (uint256 indexed tokenId,uint256 newTimestamp)",
        "event KeyGranterAdded (address indexed account)",
        "event KeyGranterRemoved (address indexed account)",
        "event KeyManagerChanged (uint256 indexed _tokenId,address indexed _newManager)",
        "event KeysMigrated (uint256 updatedRecordsCount)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event OwnershipTransferred (address previousOwner,address newOwner)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event RenewKeyPurchase (address indexed owner,uint256 newExpiration)",
        "event RoleAdminChanged (bytes32 indexed role,bytes32 indexed previousAdminRole,bytes32 indexed newAdminRole)",
        "event RoleGranted (bytes32 indexed role,address indexed account,address indexed sender)",
        "event RoleRevoked (bytes32 indexed role,address indexed account,address indexed sender)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event UnlockCallFailed (address indexed lockAddress,address unlockAddress)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
        "function KEY_GRANTER_ROLE() view returns (bytes32)",
        "function LOCK_MANAGER_ROLE() view returns (bytes32)",
        "function addKeyGranter(address account)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function approveBeneficiary(address _spender,uint256 _amount) returns (bool)",
        "function balanceOf(address _keyOwner) view returns (uint256)",
        "function beneficiary() view returns (address)",
        "function burn(uint256 _tokenId)",
        "function cancelAndRefund(uint256 _tokenId)",
        "function expirationDuration() view returns (uint256)",
        "function expireAndRefundFor(uint256 _tokenId,uint256 _amount)",
        "function extend(uint256 _value,uint256 _tokenId,address _referrer,bytes _data) payable",
        "function freeTrialLength() view returns (uint256)",
        "function gasRefundValue() view returns (uint256 _refundValue)",
        "function getApproved(uint256 _tokenId) view returns (address)",
        "function getCancelAndRefundValue(uint256 _tokenId) view returns (uint256 refund)",
        "function getHasValidKey(address _keyOwner) view returns (bool isValid)",
        "function getRoleAdmin(bytes32 role) view returns (bytes32)",
        "function getTransferFee(uint256 _tokenId,uint256 _time) view returns (uint256)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps,address[] _keyManagers)",
        "function grantRole(bytes32 role,address account)",
        "function hasRole(bytes32 role,address account) view returns (bool)",
        "function initialize(address _lockCreator,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function isApprovedForAll(address _owner,address _operator) view returns (bool)",
        "function isKeyGranter(address account) view returns (bool)",
        "function isLockManager(address account) view returns (bool)",
        "function isOwner(address account) view returns (bool)",
        "function isValidKey(uint256 _tokenId) view returns (bool)",
        "function keyExpirationTimestampFor(uint256 _tokenId) view returns (uint256)",
        "function keyManagerOf(uint256) view returns (address)",
        "function keyPrice() view returns (uint256)",
        "function maxKeysPerAddress() view returns (uint256)",
        "function maxNumberOfKeys() view returns (uint256)",
        "function mergeKeys(uint256 _tokenIdFrom,uint256 _tokenIdTo,uint256 _amount)",
        "function migrate(bytes _calldata)",
        "function name() view returns (string)",
        "function numberOfOwners() view returns (uint256)",
        "function onKeyCancelHook() view returns (address)",
        "function onKeyPurchaseHook() view returns (address)",
        "function onTokenURIHook() view returns (address)",
        "function onValidKeyHook() view returns (address)",
        "function owner() view returns (address)",
        "function ownerOf(uint256 _tokenId) view returns (address)",
        "function publicLockVersion() pure returns (uint16)",
        "function purchase(uint256[] _values,address[] _recipients,address[] _referrers,address[] _keyManagers,bytes[] _data) payable",
        "function purchasePriceFor(address _recipient,address _referrer,bytes _data) view returns (uint256 minKeyPrice)",
        "function refundPenaltyBasisPoints() view returns (uint256)",
        "function renewMembershipFor(uint256 _tokenId,address _referrer)",
        "function renounceLockManager()",
        "function renounceRole(bytes32 role,address account)",
        "function revokeKeyGranter(address _granter)",
        "function revokeRole(bytes32 role,address account)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function schemaVersion() view returns (uint256)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function setEventHooks(address _onKeyPurchaseHook,address _onKeyCancelHook,address _onValidKeyHook,address _onTokenURIHook)",
        "function setExpirationDuration(uint256 _newExpirationDuration)",
        "function setGasRefundValue(uint256 _refundValue)",
        "function setKeyManagerOf(uint256 _tokenId,address _keyManager)",
        "function setMaxKeysPerAddress(uint256 _maxKeys)",
        "function setMaxNumberOfKeys(uint256 _maxNumberOfKeys)",
        "function setOwner(address account)",
        "function shareKey(address _to,uint256 _tokenIdFrom,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) view returns (bool)",
        "function symbol() view returns (string)",
        "function tokenAddress() view returns (address)",
        "function tokenByIndex(uint256 _index) view returns (uint256)",
        "function tokenOfOwnerByIndex(address _keyOwner,uint256 _index) view returns (uint256)",
        "function tokenURI(uint256 _tokenId) view returns (string)",
        "function totalSupply() view returns (uint256)",
        "function transfer(uint256 _tokenId,address _to,uint256 _valueBasisPoint) returns (bool success)",
        "function transferFeeBasisPoints() view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function unlockProtocol() view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateSchemaVersion()",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)"
      ],
      "bytecodeHash": "0xab13b065214b7b56d27e5a3626bcb8ba4c691b34b8ebb01e1ab0fb93165fa40a"
    },
    "v11": {
      "contractName": "PublicLock",
      "abi": [
        "error CANNOT_APPROVE_SELF()",
        "error CANT_BE_SMALLER_THAN_SUPPLY()",
        "error CANT_EXTEND_NON_EXPIRING_KEY()",
        "error GAS_REFUND_FAILED()",
        "error INSUFFICIENT_ERC20_VALUE()",
        "error INSUFFICIENT_VALUE()",
        "error INVALID_ADDRESS()",
        "error INVALID_HOOK(uint8 hookIndex)",
        "error INVALID_LENGTH()",
        "error INVALID_TOKEN()",
        "error KEY_NOT_VALID()",
        "error KEY_TRANSFERS_DISABLED()",
        "error LOCK_HAS_CHANGED()",
        "error LOCK_SOLD_OUT()",
        "error MAX_KEYS_REACHED()",
        "error MIGRATION_REQUIRED()",
        "error NON_COMPLIANT_ERC721_RECEIVER()",
        "error NON_RENEWABLE_LOCK()",
        "error NOT_ENOUGH_FUNDS()",
        "error NOT_ENOUGH_TIME()",
        "error NOT_READY_FOR_RENEWAL()",
        "error NO_SUCH_KEY()",
        "error NULL_VALUE()",
        "error ONLY_KEY_MANAGER_OR_APPROVED()",
        "error ONLY_LOCK_MANAGER()",
        "error ONLY_LOCK_MANAGER_OR_BENEFICIARY()",
        "error ONLY_LOCK_MANAGER_OR_KEY_GRANTER()",
        "error OUT_OF_RANGE()",
        "error OWNER_CANT_BE_ADDRESS_ZERO()",
        "error SCHEMA_VERSION_NOT_CORRECT()",
        "error TRANSFER_TO_SELF()",
        "error UNAUTHORIZED()",
        "error UNAUTHORIZED_KEY_MANAGER_UPDATE()",
        "event Approval (address indexed owner,address indexed approved,uint256 indexed tokenId)",
        "event ApprovalForAll (address indexed owner,address indexed operator,bool approved)",
        "event CancelKey (uint256 indexed tokenId,address indexed owner,address indexed sendTo,uint256 refund)",
        "event ExpirationChanged (uint256 indexed _tokenId,uint256 _amount,bool _timeAdded)",
        "event ExpireKey (uint256 indexed tokenId)",
        "event GasRefunded (address indexed receiver,uint256 refundedAmount,address tokenAddress)",
        "event Initialized (uint8 version)",
        "event KeyExtended (uint256 indexed tokenId,uint256 newTimestamp)",
        "event KeyGranterAdded (address indexed account)",
        "event KeyGranterRemoved (address indexed account)",
        "event KeyManagerChanged (uint256 indexed _tokenId,address indexed _newManager)",
        "event KeysMigrated (uint256 updatedRecordsCount)",
        "event LockManagerAdded (address indexed account)",
        "event LockManagerRemoved (address indexed account)",
        "event NewLockSymbol (string symbol)",
        "event OwnershipTransferred (address previousOwner,address newOwner)",
        "event PricingChanged (uint256 oldKeyPrice,uint256 keyPrice,address oldTokenAddress,address tokenAddress)",
        "event RefundPenaltyChanged (uint256 freeTrialLength,uint256 refundPenaltyBasisPoints)",
        "event RoleAdminChanged (bytes32 indexed role,bytes32 indexed previousAdminRole,bytes32 indexed newAdminRole)",
        "event RoleGranted (bytes32 indexed role,address indexed account,address indexed sender)",
        "event RoleRevoked (bytes32 indexed role,address indexed account,address indexed sender)",
        "event Transfer (address indexed from,address indexed to,uint256 indexed tokenId)",
        "event TransferFeeChanged (uint256 transferFeeBasisPoints)",
        "event UnlockCallFailed (address indexed lockAddress,address unlockAddress)",
        "event Withdrawal (address indexed sender,address indexed tokenAddress,address indexed beneficiary,uint256 amount)",
        "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
        "function KEY_GRANTER_ROLE() view returns (bytes32)",
        "function LOCK_MANAGER_ROLE() view returns (bytes32)",
        "function addKeyGranter(address account)",
        "function addLockManager(address account)",
        "function approve(address _approved,uint256 _tokenId)",
        "function approveBeneficiary(address _spender,uint256 _amount) returns (bool)",
        "function balanceOf(address _keyOwner) view returns (uint256 balance)",
        "function beneficiary() view returns (address)",
        "function burn(uint256 _tokenId)",
        "function cancelAndRefund(uint256 _tokenId)",
        "function expirationDuration() view returns (uint256)",
        "function expireAndRefundFor(uint256 _tokenId,uint256 _amount)",
        "function extend(uint256 _value,uint256 _tokenId,address _referrer,bytes _data) payable",
        "function freeTrialLength() view returns (uint256)",
        "function gasRefundValue() view returns (uint256 _refundValue)",
        "function getApproved(uint256 _tokenId) view returns (address)",
        "function getCancelAndRefundValue(uint256 _tokenId) view returns (uint256 refund)",
        "function getHasValidKey(address _keyOwner) view returns (bool isValid)",
        "function getRoleAdmin(bytes32 role) view returns (bytes32)",
        "function getTransferFee(uint256 _tokenId,uint256 _time) view returns (uint256)",
        "function grantKeyExtension(uint256 _tokenId,uint256 _duration)",
        "function grantKeys(address[] _recipients,uint256[] _expirationTimestamps,address[] _keyManagers) returns (uint256[])",
        "function grantRole(bytes32 role,address account)",
        "function hasRole(bytes32 role,address account) view returns (bool)",
        "function initialize(address _lockCreator,uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function isApprovedForAll(address _owner,address _operator) view returns (bool)",
        "function isKeyGranter(address account) view returns (bool)",
        "function isLockManager(address account) view returns (bool)",
        "function isOwner(address account) view returns (bool)",
        "function isValidKey(uint256 _tokenId) view returns (bool)",
        "function keyExpirationTimestampFor(uint256 _tokenId) view returns (uint256)",
        "function keyManagerOf(uint256) view returns (address)",
        "function keyPrice() view returns (uint256)",
        "function lendKey(address _from,address _recipient,uint256 _tokenId)",
        "function maxKeysPerAddress() view returns (uint256)",
        "function maxNumberOfKeys() view returns (uint256)",
        "function mergeKeys(uint256 _tokenIdFrom,uint256 _tokenIdTo,uint256 _amount)",
        "function migrate(bytes)",
        "function name() view returns (string)",
        "function numberOfOwners() view returns (uint256)",
        "function onKeyCancelHook() view returns (address)",
        "function onKeyPurchaseHook() view returns (address)",
        "function onKeyTransferHook() view returns (address)",
        "function onTokenURIHook() view returns (address)",
        "function onValidKeyHook() view returns (address)",
        "function owner() view returns (address)",
        "function ownerOf(uint256 _tokenId) view returns (address)",
        "function publicLockVersion() pure returns (uint16)",
        "function purchase(uint256[] _values,address[] _recipients,address[] _referrers,address[] _keyManagers,bytes[] _data) payable returns (uint256[])",
        "function purchasePriceFor(address _recipient,address _referrer,bytes _data) view returns (uint256 minKeyPrice)",
        "function referrerFees(address) view returns (uint256)",
        "function refundPenaltyBasisPoints() view returns (uint256)",
        "function renewMembershipFor(uint256 _tokenId,address _referrer)",
        "function renounceLockManager()",
        "function renounceRole(bytes32 role,address account)",
        "function revokeKeyGranter(address _granter)",
        "function revokeRole(bytes32 role,address account)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId)",
        "function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes _data)",
        "function schemaVersion() view returns (uint256)",
        "function setApprovalForAll(address _to,bool _approved)",
        "function setBaseTokenURI(string _baseTokenURI)",
        "function setEventHooks(address _onKeyPurchaseHook,address _onKeyCancelHook,address _onValidKeyHook,address _onTokenURIHook,address _onKeyTransferHook)",
        "function setExpirationDuration(uint256 _newExpirationDuration)",
        "function setGasRefundValue(uint256 _refundValue)",
        "function setKeyManagerOf(uint256 _tokenId,address _keyManager)",
        "function setMaxKeysPerAddress(uint256 _maxKeys)",
        "function setMaxNumberOfKeys(uint256 _maxNumberOfKeys)",
        "function setOwner(address account)",
        "function setReferrerFee(address _referrer,uint256 _feeBasisPoint)",
        "function shareKey(address _to,uint256 _tokenIdFrom,uint256 _timeShared)",
        "function supportsInterface(bytes4 interfaceId) view returns (bool)",
        "function symbol() view returns (string)",
        "function tokenAddress() view returns (address)",
        "function tokenByIndex(uint256 _index) view returns (uint256)",
        "function tokenOfOwnerByIndex(address _keyOwner,uint256 _index) view returns (uint256)",
        "function tokenURI(uint256 _tokenId) view returns (string)",
        "function totalKeys(address _keyOwner) view returns (uint256)",
        "function totalSupply() view returns (uint256)",
        "function transfer(uint256 _tokenId,address _to,uint256 _valueBasisPoint) returns (bool success)",
        "function transferFeeBasisPoints() view returns (uint256)",
        "function transferFrom(address _from,address _recipient,uint256 _tokenId)",
        "function unlendKey(address _recipient,uint256 _tokenId)",
        "function unlockProtocol() view returns (address)",
        "function updateBeneficiary(address _beneficiary)",
        "function updateKeyPricing(uint256 _keyPrice,address _tokenAddress)",
        "function updateLockName(string _lockName)",
        "function updateLockSymbol(string _lockSymbol)",
        "function updateRefundPenalty(uint256 _freeTrialLength,uint256 _refundPenaltyBasisPoints)",
        "function updateSchemaVersion()",
        "function updateTransferFee(uint256 _transferFeeBasisPoints)",
        "function withdraw(address _tokenAddress,uint256 _amount)"
      ],
      "bytecodeHash": "0x2cc5097486050fd8d352e6f0bb5e5044510093b9c71879538bb182699c12cd88"
    }
  },
  "Unlock": {
    "v4": {
      "contractName": "Unlock",
      "abi": [
        "function locks(address) constant view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function renounceOwnership()",
        "function owner() constant view returns (address)",
        "function isOwner() constant view returns (bool)",
        "function totalDiscountGranted() constant view returns (uint256)",
        "function grossNetworkProduct() constant view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event NewTokenURI (string tokenURI)",
        "event NewGlobalTokenSymbol (string tokenSymbol)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "function initialize(address _owner)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName)",
        "function computeAvailableDiscountFor(address _purchaser,uint256 _keyPrice) constant view returns (uint256 discount,uint256 tokens)",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function recordConsumedDiscount(uint256 _discount,uint256 _tokens)",
        "function unlockVersion() constant pure returns (uint16)",
        "function getGlobalBaseTokenURI() constant view returns (string)",
        "function setGlobalBaseTokenURI(string _URI)",
        "function getGlobalTokenSymbol() constant view returns (string)",
        "function setGlobalTokenSymbol(string _symbol)"
      ],
      "bytecodeHash": "0xa1e7ddfa6d9183443aca067a96bd252f3ffa72a55ce36564ab77e79ce6527ac3"
    },
    "v6": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (address publicLockAddress,string globalTokenSymbol,string globalTokenURI)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "function globalBaseTokenURI() constant view returns (string)",
        "function globalTokenSymbol() constant view returns (string)",
        "function grossNetworkProduct() constant view returns (uint256)",
        "function isOwner() constant view returns (bool)",
        "function locks(address) constant view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function owner() constant view returns (address)",
        "function publicLockAddress() constant view returns (address)",
        "function renounceOwnership()",
        "function totalDiscountGranted() constant view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function uniswapExchanges(address) constant view returns (address)",
        "function initialize(address _owner)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12 _salt)",
        "function computeAvailableDiscountFor(address _purchaser,uint256 _keyPrice) constant view returns (uint256 discount,uint256 tokens)",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function recordConsumedDiscount(uint256 _discount,uint256 _tokens)",
        "function unlockVersion() constant pure returns (uint16)",
        "function configUnlock(address _publicLockAddress,string _symbol,string _URI)",
        "function setExchange(address _tokenAddress,address _exchangeAddress)",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)"
      ],
      "bytecodeHash": "0x7b0e23742d9e4cbda29162687b753336c14d9afa6372385323f3a32a1365f535"
    },
    "v7": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (string globalTokenSymbol,string globalTokenURI)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "event SetLockTemplate (address publicLockAddress)",
        "function globalBaseTokenURI() constant view returns (string)",
        "function globalTokenSymbol() constant view returns (string)",
        "function grossNetworkProduct() constant view returns (uint256)",
        "function isOwner() constant view returns (bool)",
        "function locks(address) constant view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function owner() constant view returns (address)",
        "function publicLockAddress() constant view returns (address)",
        "function renounceOwnership()",
        "function totalDiscountGranted() constant view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function uniswapExchanges(address) constant view returns (address)",
        "function initialize(address _unlockOwner)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12 _salt)",
        "function computeAvailableDiscountFor(address,uint256) constant view returns (uint256 discount,uint256 tokens)",
        "function recordKeyPurchase(uint256 _value,address)",
        "function recordConsumedDiscount(uint256 _discount,uint256)",
        "function unlockVersion() constant pure returns (uint16)",
        "function configUnlock(string _symbol,string _URI)",
        "function setLockTemplate(address _publicLockAddress)",
        "function setExchange(address _tokenAddress,address _exchangeAddress)",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)",
        "function getGlobalBaseTokenURI() constant view returns (string)",
        "function getGlobalTokenSymbol() constant view returns (string)"
      ],
      "bytecodeHash": "0x2f4767420e3b4affa1e3169450a565061cab422cdf7cd582179eb33b0480da0b"
    },
    "v8": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (address udt,address weth,uint256 estimatedGasForPurchase,string globalTokenSymbol,string globalTokenURI)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "event SetLockTemplate (address publicLockAddress)",
        "function estimatedGasForPurchase() constant view returns (uint256)",
        "function globalBaseTokenURI() constant view returns (string)",
        "function globalTokenSymbol() constant view returns (string)",
        "function grossNetworkProduct() constant view returns (uint256)",
        "function isOwner() constant view returns (bool)",
        "function locks(address) constant view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function owner() constant view returns (address)",
        "function publicLockAddress() constant view returns (address)",
        "function renounceOwnership()",
        "function totalDiscountGranted() constant view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function udt() constant view returns (address)",
        "function uniswapOracles(address) constant view returns (address)",
        "function weth() constant view returns (address)",
        "function initialize(address _unlockOwner)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12 _salt)",
        "function computeAvailableDiscountFor(address,uint256) constant view returns (uint256 discount,uint256 tokens)",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function recordConsumedDiscount(uint256 _discount,uint256)",
        "function unlockVersion() constant pure returns (uint16)",
        "function configUnlock(address _udt,address _weth,uint256 _estimatedGasForPurchase,string _symbol,string _URI)",
        "function setLockTemplate(address _publicLockAddress)",
        "function setOracle(address _tokenAddress,address _oracleAddress)",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)",
        "function getGlobalBaseTokenURI() constant view returns (string)",
        "function getGlobalTokenSymbol() constant view returns (string)"
      ],
      "bytecodeHash": "0xa757523ba876af736fe51084850937c0750049a724990558f1753fe9d0b0ec5e"
    },
    "v9": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (address udt,address weth,uint256 estimatedGasForPurchase,string globalTokenSymbol,string globalTokenURI,uint256 chainId)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "event SetLockTemplate (address publicLockAddress)",
        "function chainId() constant view returns (uint256)",
        "function estimatedGasForPurchase() constant view returns (uint256)",
        "function globalBaseTokenURI() constant view returns (string)",
        "function globalTokenSymbol() constant view returns (string)",
        "function grossNetworkProduct() constant view returns (uint256)",
        "function isOwner() constant view returns (bool)",
        "function locks(address) constant view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function owner() constant view returns (address)",
        "function publicLockAddress() constant view returns (address)",
        "function renounceOwnership()",
        "function totalDiscountGranted() constant view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function udt() constant view returns (address)",
        "function uniswapOracles(address) constant view returns (address)",
        "function weth() constant view returns (address)",
        "function initialize(address _unlockOwner)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12 _salt)",
        "function computeAvailableDiscountFor(address,uint256) constant view returns (uint256 discount,uint256 tokens)",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function recordConsumedDiscount(uint256 _discount,uint256)",
        "function unlockVersion() constant pure returns (uint16)",
        "function configUnlock(address _udt,address _weth,uint256 _estimatedGasForPurchase,string _symbol,string _URI,uint256 _chainId)",
        "function setLockTemplate(address _publicLockAddress)",
        "function setOracle(address _tokenAddress,address _oracleAddress)",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)",
        "function getGlobalBaseTokenURI() constant view returns (string)",
        "function getGlobalTokenSymbol() constant view returns (string)"
      ],
      "bytecodeHash": "0xc5ea0fd202dd361f7dcc45b751f2c2d46a796e3a53c7e75dc1c16cf5285b5a8e"
    },
    "v10": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (address udt,address weth,uint256 estimatedGasForPurchase,string globalTokenSymbol,string globalTokenURI,uint256 chainId)",
        "event LockUpgraded (address lockAddress,uint16 version)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "event SetLockTemplate (address publicLockAddress)",
        "event UnlockTemplateAdded (address indexed impl,uint16 indexed version)",
        "function __initializeOwnable(address sender)",
        "function addLockTemplate(address impl,uint16 version)",
        "function chainId() view returns (uint256)",
        "function computeAvailableDiscountFor(address,uint256) pure returns (uint256 discount,uint256 tokens)",
        "function configUnlock(address _udt,address _weth,uint256 _estimatedGasForPurchase,string _symbol,string _URI,uint256 _chainId)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12) returns (address)",
        "function createUpgradeableLock(bytes data) returns (address)",
        "function estimatedGasForPurchase() view returns (uint256)",
        "function getGlobalBaseTokenURI() view returns (string)",
        "function getGlobalTokenSymbol() view returns (string)",
        "function globalBaseTokenURI() view returns (string)",
        "function globalTokenSymbol() view returns (string)",
        "function grossNetworkProduct() view returns (uint256)",
        "function initialize(address _unlockOwner)",
        "function initializeProxyAdmin()",
        "function isOwner() view returns (bool)",
        "function locks(address) view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function owner() view returns (address)",
        "function proxyAdminAddress() view returns (address)",
        "function publicLockAddress() view returns (address)",
        "function publicLockImpls(uint16 _version) view returns (address)",
        "function publicLockLatestVersion() view returns (uint16)",
        "function publicLockVersions(address _impl) view returns (uint16)",
        "function recordConsumedDiscount(uint256,uint256) view",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function renounceOwnership()",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)",
        "function setLockTemplate(address _publicLockAddress)",
        "function setOracle(address _tokenAddress,address _oracleAddress)",
        "function totalDiscountGranted() view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function udt() view returns (address)",
        "function uniswapOracles(address) view returns (address)",
        "function unlockVersion() pure returns (uint16)",
        "function upgradeLock(address lockAddress,uint16 version) returns (address)",
        "function weth() view returns (address)"
      ],
      "bytecodeHash": "0x81e49b5cc6f523a46b17d6d6b3658eb34eab85dee56a711bdb06f66358002555"
    },
    "v11": {
      "contractName": "Unlock",
      "abi": [
        "event ConfigUnlock (address udt,address weth,uint256 estimatedGasForPurchase,string globalTokenSymbol,string globalTokenURI,uint256 chainId)",
        "event GNPChanged (uint256 grossNetworkProduct,uint256 _valueInETH,address tokenAddress,uint256 value,address lockAddress)",
        "event LockUpgraded (address lockAddress,uint16 version)",
        "event NewLock (address indexed lockOwner,address indexed newLockAddress)",
        "event OwnershipTransferred (address indexed previousOwner,address indexed newOwner)",
        "event ResetTrackedValue (uint256 grossNetworkProduct,uint256 totalDiscountGranted)",
        "event SetLockTemplate (address publicLockAddress)",
        "event UnlockTemplateAdded (address indexed impl,uint16 indexed version)",
        "function __initializeOwnable(address sender)",
        "function addLockTemplate(address impl,uint16 version)",
        "function chainId() view returns (uint256)",
        "function computeAvailableDiscountFor(address,uint256) pure returns (uint256 discount,uint256 tokens)",
        "function configUnlock(address _udt,address _weth,uint256 _estimatedGasForPurchase,string _symbol,string _URI,uint256 _chainId)",
        "function createLock(uint256 _expirationDuration,address _tokenAddress,uint256 _keyPrice,uint256 _maxNumberOfKeys,string _lockName,bytes12) returns (address)",
        "function createUpgradeableLock(bytes data) returns (address)",
        "function createUpgradeableLockAtVersion(bytes data,uint16 _lockVersion) returns (address)",
        "function estimatedGasForPurchase() view returns (uint256)",
        "function getGlobalBaseTokenURI() view returns (string)",
        "function getGlobalTokenSymbol() view returns (string)",
        "function globalBaseTokenURI() view returns (string)",
        "function globalTokenSymbol() view returns (string)",
        "function grossNetworkProduct() view returns (uint256)",
        "function initialize(address _unlockOwner)",
        "function initializeProxyAdmin()",
        "function isOwner() view returns (bool)",
        "function locks(address) view returns (bool deployed,uint256 totalSales,uint256 yieldedDiscountTokens)",
        "function networkBaseFee() view returns (uint256)",
        "function owner() view returns (address)",
        "function proxyAdminAddress() view returns (address)",
        "function publicLockAddress() view returns (address)",
        "function publicLockImpls(uint16 _version) view returns (address)",
        "function publicLockLatestVersion() view returns (uint16)",
        "function publicLockVersions(address _impl) view returns (uint16)",
        "function recordConsumedDiscount(uint256,uint256) view",
        "function recordKeyPurchase(uint256 _value,address _referrer)",
        "function renounceOwnership()",
        "function resetTrackedValue(uint256 _grossNetworkProduct,uint256 _totalDiscountGranted)",
        "function setLockTemplate(address _publicLockAddress)",
        "function setOracle(address _tokenAddress,address _oracleAddress)",
        "function totalDiscountGranted() view returns (uint256)",
        "function transferOwnership(address newOwner)",
        "function udt() view returns (address)",
        "function uniswapOracles(address) view returns (address)",
        "function unlockVersion() pure returns (uint16)",
        "function upgradeLock(address lockAddress,uint16 version) returns (address)",
        "function weth() view returns (address)"
      ],
      "bytecodeHash": "0xa7e4659ad2ab8fff93d896c39a634e985bc475dac4caa8a0494433e53d9a9574"
    }
  }
};
var abis_default = abis;

// src/constants.ts
import { ethers as ethers2 } from "ethers";
var MAX_UINT = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
var ETHERS_MAX_UINT = ethers2.constants.MaxUint256;
var UNLIMITED_KEYS_COUNT = -1;
var ZERO = ethers2.constants.AddressZero;

// src/erc20.ts
import { ethers as ethers3 } from "ethers";

// src/erc20abi.ts
var erc20abi = [
  "function totalSupply() public view returns (uint)",
  "function balanceOf(address tokenOwner) public view returns (uint balance)",
  "function decimals() public view returns (uint decimals)",
  "function allowance(address tokenOwner, address spender) public view returns (uint remaining)",
  "function transfer(address to, uint tokens) public returns (bool success)",
  "function approve(address spender, uint tokens) public returns (bool success)",
  "function transferFrom(address from, address to, uint tokens) public returns (bool success)",
  "function symbol() public view returns (string)",
  "event Transfer(address indexed from, address indexed to, uint tokens)",
  "event Approval(address indexed tokenOwner, address indexed spender, uint tokens)"
];
var erc20abi_default = erc20abi;

// src/erc20.ts
var SAI_ADDRESS = "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359".toLowerCase();
async function getErc20BalanceForAddress(erc20ContractAddress, address, provider) {
  const contract = new ethers3.Contract(erc20ContractAddress, erc20abi_default, provider);
  const balance = await contract.balanceOf(address);
  return utils_default.hexToNumberString(balance);
}
async function getErc20Decimals(erc20ContractAddress, provider) {
  const contract = new ethers3.Contract(erc20ContractAddress, erc20abi_default, provider);
  let decimals;
  try {
    decimals = await contract.decimals();
  } catch (e) {
    return 18;
  }
  return utils_default.toNumber(decimals);
}
async function getErc20TokenSymbol(erc20ContractAddress, provider) {
  if (erc20ContractAddress.toLowerCase() === SAI_ADDRESS) {
    return "SAI";
  }
  const contract = new ethers3.Contract(erc20ContractAddress, erc20abi_default, provider);
  let symbol;
  try {
    symbol = await contract.symbol();
  } catch (e) {
    return null;
  }
  return symbol;
}
async function getAllowance(erc20ContractAddress, lockContractAddress, provider, spenderAddress) {
  const contract = new ethers3.Contract(erc20ContractAddress, erc20abi_default, provider);
  let amount = ethers3.BigNumber.from(0);
  try {
    amount = await contract.allowance(spenderAddress, lockContractAddress);
  } catch (e) {
  }
  return amount;
}
async function approveTransfer(erc20ContractAddress, lockContractAddress, value, provider, signer) {
  const contract = new ethers3.Contract(erc20ContractAddress, erc20abi_default, signer);
  return contract.approve(lockContractAddress, value);
}

// src/PublicLock/v4/purchaseKey.js
async function purchaseKey_default({ lockAddress, owner, keyPrice, erc20Address, decimals }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!owner) {
    owner = await this.signer.getAddress();
  }
  if (!erc20Address || erc20Address !== ZERO) {
    erc20Address = await lockContract.tokenAddress();
  }
  let actualAmount;
  if (!keyPrice) {
    actualAmount = await lockContract.keyPrice();
  } else if (decimals == null) {
    if (erc20Address && erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
    actualAmount = utils_default.toDecimal(keyPrice, decimals);
  }
  const purchaseForOptions = {};
  if (erc20Address && erc20Address !== ZERO) {
    const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
    if (!approvedAmount || approvedAmount.lt(actualAmount)) {
      await (await approveTransfer(erc20Address, lockAddress, actualAmount, this.provider, this.signer)).wait();
    }
  } else {
    purchaseForOptions.value = actualAmount;
  }
  const transactionPromise = lockContract.purchaseFor(owner, purchaseForOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  if (receipt.status === 0) {
    throw new Error("Transaction failed");
  }
  const parser = lockContract.interface;
  const transferEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  })[0];
  if (transferEvent) {
    return transferEvent.args._tokenId.toString();
  }
  return null;
}

// src/PublicLock/utils/formatKeyPrice.js
var formatKeyPrice_default = async (keyPrice, erc20Address, decimals, provider) => {
  let actualAmount;
  if (decimals !== void 0 && decimals !== null) {
    actualAmount = utils_default.toDecimal(keyPrice, decimals);
  } else {
    if (erc20Address && erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, provider);
    } else {
      decimals = 18;
    }
    actualAmount = utils_default.toDecimal(keyPrice, decimals);
  }
  return actualAmount;
};

// src/PublicLock/utils/multiplePurchaseWrapper.js
async function multiplePurchaseWrapper_default(purchaseKey3, {
  lockAddress,
  erc20Address,
  decimals,
  owners = [],
  keyManagers = [],
  keyPrices = [],
  referrers = [],
  data = []
}, callback) {
  if (!erc20Address) {
    const lockContract = await this.getLockContract(lockAddress);
    erc20Address = await lockContract.tokenAddress();
    if (erc20Address !== ZERO) {
      const prices = await Promise.all((keyPrices || Array(owners.length).fill(null)).map(async (kp) => kp ? lockContract.keyPrice() : formatKeyPrice_default(kp, erc20Address, decimals, this.provider)));
      const totalPrice = prices.reduce((total, kp) => total.add(kp), utils_default.bigNumberify(0));
      const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
      if (!approvedAmount || approvedAmount.lt(totalPrice)) {
        await (await approveTransfer(erc20Address, lockAddress, totalPrice, this.provider, this.signer)).wait();
      }
    }
  }
  return Promise.all(owners.map(async (owner, i) => purchaseKey3.bind(this)({
    lockAddress,
    owner,
    keyManager: keyManagers[i],
    keyPrice: keyPrices[i],
    referrer: referrers[i],
    data: data[i],
    erc20Address,
    decimals
  }, callback)));
}

// src/PublicLock/v4/purchaseKeys.js
async function purchaseKeys_default(params, callback) {
  return await multiplePurchaseWrapper_default.bind(this)(purchaseKey_default, params, callback);
}

// src/PublicLock/v4/grantKeys.js
async function grantKeys_default({ lockAddress, recipients, expirations }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!(expirations == null ? void 0 : expirations.length)) {
    const duration = await lockContract.expirationDuration();
    if (ETHERS_MAX_UINT.eq(duration)) {
      expirations = new Array(recipients.length).fill(ETHERS_MAX_UINT);
    } else {
      expirations = new Array(recipients.length).fill(Math.floor(new Date().getTime() / 1e3 + duration.toNumber()));
    }
  }
  if (recipients.length !== expirations.length) {
    throw new Error("Number of recipients don't match the number of expirations provided");
  }
  const grantKeysOptions = {};
  const transactionPromise = lockContract["grantKeys(address[],uint256[])"](recipients, expirations, grantKeysOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const transferEvents = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  });
  if (transferEvents.length) {
    return transferEvents.map((item) => item.args._tokenId.toString());
  }
  return null;
}

// src/PublicLock/v4/grantKey.js
async function grantKey_default({ lockAddress, recipient, expiration }, callback) {
  const events = await grantKeys_default.bind(this)({
    lockAddress,
    recipients: [recipient],
    expirations: expiration ? [expiration] : []
  }, callback);
  if (events == null ? void 0 : events.length) {
    return events[0];
  }
  return null;
}

// src/PublicLock/v4/updateKeyPrice.js
async function updateKeyPrice_default({ lockAddress, keyPrice, decimals, erc20Address }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (decimals == null) {
    if (!erc20Address) {
      erc20Address = await lockContract.tokenAddress();
    }
    if (erc20Address && erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
  }
  const actualAmount = utils_default.toDecimal(keyPrice, decimals);
  const transactionPromise = lockContract["updateKeyPrice(uint256)"](actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const priceChangedEvent = receipt.logs.map((log) => {
    return parser.parseLog(log);
  }).filter((event) => {
    return event.signature === "PriceChanged(uint256,uint256)";
  })[0];
  if (priceChangedEvent) {
    return utils_default.fromDecimal(priceChangedEvent.args.keyPrice, decimals);
  }
  return null;
}

// src/PublicLock/v4/withdrawFromLock.js
async function withdrawFromLock_default({ lockAddress, amount = "0", decimals = 18 }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const actualAmount = utils_default.toDecimal(amount, decimals);
  const transactionPromise = lockContract["withdraw(uint256)"](actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const withdrawalEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Withdrawal";
  })[0];
  if (withdrawalEvent) {
    return utils_default.fromWei(withdrawalEvent.args.amount.toString(), "ether");
  }
  return null;
}

// src/PublicLock/v4/isLockManager.js
async function isLockManager_default(lockAddres, userAddress, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  const owner = await lockContract.owner();
  return owner.toLowerCase() === userAddress.toLowerCase();
}

// src/PublicLock/v4/cancelAndRefund.js
async function cancelAndRefund_default({ lockAddress }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.cancelAndRefund();
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/utils/parseLockGetters.js
var attributes = {
  name: (x) => x,
  keyPrice: (x) => x,
  expirationDuration: (value) => {
    if (utils_default.isInfiniteDuration(value)) {
      return -1;
    }
    return parseInt(value, 10);
  },
  maxNumberOfKeys: (value) => {
    if (utils_default.isInfiniteKeys(value)) {
      return UNLIMITED_KEYS_COUNT;
    }
    return utils_default.toNumber(value);
  },
  maxKeysPerAddress: parseInt,
  beneficiary: (x) => x,
  totalSupply: parseInt,
  tokenAddress: (x) => x,
  publicLockVersion: parseInt,
  unlockProtocol: (x) => x
};
async function parseLockGetters_default(address, provider) {
  const contract = await this.getLockContract(address, provider);
  const getBlockNumber = async () => {
    const blockNumber = await provider.getBlockNumber();
    update.asOf = blockNumber;
  };
  const update = {};
  const constantPromises = Object.keys(attributes).filter((func) => Object.keys(contract).includes(func)).map(async (attribute) => {
    const result = await contract.functions[`${attribute}()`]();
    update[attribute] = attributes[attribute](result[0]);
  });
  constantPromises.push(getBlockNumber());
  await Promise.all(constantPromises);
  if (update.tokenAddress === ZERO) {
    update.keyPrice = utils_default.fromWei(update.keyPrice, "ether");
    const balance = await provider.getBalance(address);
    update.balance = utils_default.fromWei(balance, "ether");
  } else {
    const erc20Decimals = await getErc20Decimals(update.tokenAddress, provider);
    const erc20Balance = await getErc20BalanceForAddress(update.tokenAddress, address, provider);
    const erc20Symbol = await getErc20TokenSymbol(update.tokenAddress, provider);
    update.keyPrice = utils_default.fromDecimal(update.keyPrice, erc20Decimals);
    update.balance = utils_default.fromDecimal(erc20Balance, erc20Decimals);
    update.currencySymbol = erc20Symbol;
  }
  update.outstandingKeys = update.totalSupply;
  delete update.totalSupply;
  if (update.tokenAddress === ZERO) {
    update.currencyContractAddress = null;
  } else {
    update.currencyContractAddress = update.tokenAddress;
  }
  delete update.tokenAddress;
  if (update.unlockProtocol) {
    update.unlockContractAddress = update.unlockProtocol;
    delete update.unlockProtocol;
  }
  return update;
}

// src/PublicLock/v4/getLock.js
async function getLock_default(address, provider) {
  const update = await parseLockGetters_default.bind(this)(address, provider);
  return update;
}

// src/PublicLock/v4/getTokenIdForOwner.js
async function getTokenIdForOwner_default(lockAddress, owner, network) {
  const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
  try {
    const tokenId = await lockContract.getTokenIdFor(owner);
    return parseInt(tokenId, 10);
  } catch (error) {
    return 0;
  }
}

// src/PublicLock/v4/getKeyExpirationByLockForOwner.js
async function getKeyExpirationByLockForOwner_default(lockAddress, owner, network) {
  const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
  if (await lockContract.publicLockVersion() > 10) {
    throw new Error("Only available until Lock v10");
  }
  try {
    const expiration = await lockContract.keyExpirationTimestampFor(owner);
    if (expiration == "3963877391197344453575983046348115674221700746820753546331534351508065746944") {
      return 0;
    }
    if (expiration.eq(ETHERS_MAX_UINT)) {
      return -1;
    }
    return parseInt(expiration, 10);
  } catch (error) {
    return 0;
  }
}

// src/PublicLock/v4/totalKeys.js
async function totalKeys_default(lockAddres, owner, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  return lockContract.balanceOf(owner);
}

// src/PublicLock/v4/index.js
var v4_default = {
  purchaseKey: purchaseKey_default,
  purchaseKeys: purchaseKeys_default,
  grantKey: grantKey_default,
  grantKeys: grantKeys_default,
  updateKeyPrice: updateKeyPrice_default,
  getLock: getLock_default,
  withdrawFromLock: withdrawFromLock_default,
  isLockManager: isLockManager_default,
  version: "v4",
  Unlock: abis_default.Unlock.v4,
  PublicLock: abis_default.PublicLock.v4,
  cancelAndRefund: cancelAndRefund_default,
  getTokenIdForOwner: getTokenIdForOwner_default,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner_default,
  totalKeys: totalKeys_default
};

// src/PublicLock/v6/purchaseKey.js
async function purchaseKey_default2({ lockAddress, owner, keyPrice, erc20Address, decimals, referrer, data }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!owner) {
    owner = await this.signer.getAddress();
  }
  if (!referrer) {
    referrer = ZERO;
  }
  if (!data) {
    data = [];
  }
  if (!erc20Address) {
    erc20Address = await lockContract.tokenAddress();
  }
  let actualAmount;
  if (!keyPrice) {
    actualAmount = await lockContract.keyPrice();
  } else if (decimals !== void 0 && decimals !== null) {
    actualAmount = utils_default.toDecimal(keyPrice, decimals);
  } else {
    if (erc20Address && erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
    actualAmount = utils_default.toDecimal(keyPrice, decimals);
  }
  const purchaseForOptions = {};
  if (erc20Address && erc20Address !== ZERO) {
    const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
    if (!approvedAmount || approvedAmount.lt(actualAmount)) {
      await (await approveTransfer(erc20Address, lockAddress, actualAmount, this.provider, this.signer)).wait();
    }
  } else {
    purchaseForOptions.value = actualAmount;
  }
  if (!purchaseForOptions.gasLimit) {
    try {
      const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = await this.provider.getFeeData();
      if (maxFeePerGas && maxPriorityFeePerGas) {
        purchaseForOptions.maxFeePerGas = maxFeePerGas;
        purchaseForOptions.maxPriorityFeePerGas = maxPriorityFeePerGas;
      } else {
        purchaseForOptions.gasPrice = gasPrice;
      }
      const gasLimit = await lockContract.estimateGas.purchase(actualAmount, owner, referrer, data, purchaseForOptions);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
      purchaseForOptions.gasLimit = gasLimit.mul(13).div(10).toNumber();
    } catch (error) {
      console.error("We could not estimate gas ourselves. Let wallet do it.", error);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
    }
  }
  const transactionPromise = lockContract.purchase(actualAmount, owner, referrer, data, purchaseForOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  if (receipt.status === 0) {
    throw new Error("Transaction failed");
  }
  const parser = lockContract.interface;
  const transferEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  })[0];
  if (transferEvent) {
    return transferEvent.args.tokenId.toString();
  }
  return null;
}

// src/PublicLock/v6/purchaseKeys.js
async function purchaseKeys_default2(params, callback) {
  return await multiplePurchaseWrapper_default.bind(this)(purchaseKey_default2, params, callback);
}

// src/PublicLock/v6/grantKeys.js
async function grantKeys_default2({ lockAddress, recipients, expirations, transactionOptions }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!(expirations == null ? void 0 : expirations.length)) {
    const duration = await lockContract.expirationDuration();
    if (ETHERS_MAX_UINT.eq(duration)) {
      expirations = new Array(recipients.length).fill(ETHERS_MAX_UINT);
    } else {
      expirations = new Array(recipients.length).fill(Math.floor(new Date().getTime() / 1e3 + duration.toNumber()));
    }
  }
  if (recipients.length !== expirations.length) {
    throw new Error("Number of recipients don't match the number of expirations provided");
  }
  const transactionPromise = lockContract.grantKeys(recipients, expirations, transactionOptions || {});
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const transferEvents = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  });
  if (transferEvents.length) {
    return transferEvents.map((item) => item.args.tokenId.toString());
  }
  return null;
}

// src/PublicLock/v6/grantKey.js
async function grantKey_default2({ lockAddress, recipient, expiration, transactionOptions }, callback) {
  const events = await grantKeys_default2.bind(this)({
    lockAddress,
    transactionOptions,
    recipients: [recipient],
    expirations: expiration ? [expiration] : []
  }, callback);
  if (events == null ? void 0 : events.length) {
    return events[0];
  }
  return null;
}

// src/PublicLock/v6/updateKeyPrice.js
async function updateKeyPrice_default2({ lockAddress, keyPrice, decimals, erc20Address }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address) {
    erc20Address = await lockContract.tokenAddress();
  }
  if (decimals == null) {
    if (erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
  }
  const actualAmount = utils_default.toDecimal(keyPrice, decimals);
  const transactionPromise = lockContract.updateKeyPricing(actualAmount, erc20Address || ZERO);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const priceChangedEvent = receipt.logs.map((log) => {
    return parser.parseLog(log);
  }).filter((event) => {
    return event.name === "PricingChanged";
  })[0];
  if (priceChangedEvent) {
    return utils_default.fromDecimal(priceChangedEvent.args.keyPrice, decimals);
  }
  return null;
}

// src/PublicLock/v6/withdrawFromLock.js
async function withdrawFromLock_default2({ erc20Address, lockAddress, amount = "0", decimals }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address || erc20Address !== ZERO) {
    erc20Address = await lockContract.tokenAddress();
  }
  if (decimals == null) {
    if (erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
  }
  const actualAmount = utils_default.toDecimal(amount, decimals);
  const transactionPromise = lockContract.withdraw(erc20Address, actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const withdrawalEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Withdrawal";
  })[0];
  if (withdrawalEvent) {
    return utils_default.fromWei(withdrawalEvent.args.amount.toString(), "ether");
  }
  return null;
}

// src/PublicLock/v6/initializeTemplate.js
async function initializeTemplate_default({ templateAddress }, callback) {
  const owner = await this.signer.getAddress();
  const expirationDuration = 0;
  const tokenAddress = ZERO;
  const keyPrice = 0;
  const maxNumberOfKeys = 0;
  const lockName = "Public Lock Template";
  const contract = await this.getLockContract(templateAddress);
  const initializeTransaction = await contract.initialize(owner, expirationDuration, tokenAddress, keyPrice, maxNumberOfKeys, lockName);
  if (callback) {
    callback(null, initializeTransaction.hash);
  }
  await this.provider.waitForTransaction(initializeTransaction.hash);
}

// src/PublicLock/v6/isLockManager.js
async function isLockManager_default2(lockAddres, userAddress, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  const owner = await lockContract.owner();
  return owner.toLowerCase() === userAddress.toLowerCase();
}

// src/PublicLock/v6/cancelAndRefund.js
async function cancelAndRefund_default2({ lockAddress }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.cancelAndRefund();
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v6/shareKey.js
async function shareKey_default({ lockAddress, tokenId, recipient, duration }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!tokenId) {
    const owner = await this.signer.getAddress();
    tokenId = await lockContract.getTokenIdFor(owner);
  }
  if (!duration) {
    const keyOwner = await lockContract.ownerOf(tokenId);
    const expiration = await lockContract.keyExpirationTimestampFor(keyOwner);
    duration = Math.floor(new Date().getTime() / 1e3) - expiration.toNumber();
  }
  const transactionOptions = {};
  const transactionPromise = lockContract.shareKey(recipient, tokenId, duration, transactionOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  return await this.provider.waitForTransaction(hash);
}

// src/PublicLock/v6/getLock.js
async function getLock_default2(address, provider) {
  const update = await parseLockGetters_default.bind(this)(address, provider);
  return update;
}

// src/PublicLock/v6/index.js
var { getTokenIdForOwner, getKeyExpirationByLockForOwner, totalKeys } = v4_default;
var v6_default = {
  version: "v6",
  Unlock: abis_default.Unlock.v6,
  PublicLock: abis_default.PublicLock.v6,
  initializeTemplate: initializeTemplate_default,
  updateKeyPrice: updateKeyPrice_default2,
  purchaseKey: purchaseKey_default2,
  purchaseKeys: purchaseKeys_default2,
  getLock: getLock_default2,
  grantKey: grantKey_default2,
  grantKeys: grantKeys_default2,
  withdrawFromLock: withdrawFromLock_default2,
  isLockManager: isLockManager_default2,
  cancelAndRefund: cancelAndRefund_default2,
  shareKey: shareKey_default,
  getTokenIdForOwner,
  getKeyExpirationByLockForOwner,
  totalKeys
};

// src/PublicLock/v7/grantKeys.js
async function grantKeys_default3({ lockAddress, recipients, expirations, keyManagers, transactionOptions }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!(expirations == null ? void 0 : expirations.length)) {
    const duration = await lockContract.expirationDuration();
    if (ETHERS_MAX_UINT.eq(duration)) {
      expirations = new Array(recipients.length).fill(ETHERS_MAX_UINT);
    } else {
      expirations = new Array(recipients.length).fill(Math.floor(new Date().getTime() / 1e3 + duration.toNumber()));
    }
  }
  if (!(keyManagers == null ? void 0 : keyManagers.length)) {
    const signer = this.signer;
    const manager = await signer.getAddress();
    keyManagers = new Array(recipients.length).fill(manager);
  }
  if (recipients.length !== expirations.length) {
    throw new Error("Number of recipients don't match the number of expirations provided");
  }
  if (recipients.length !== keyManagers.length) {
    throw new Error("Number of recipients don't match the number of keyManagers provided");
  }
  const transactionPromise = lockContract.grantKeys(recipients, expirations, keyManagers, transactionOptions || {});
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = lockContract.interface;
  const transferEvents = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  });
  if (transferEvents.length) {
    return transferEvents.map((item) => item.args.tokenId.toString());
  }
  return null;
}

// src/PublicLock/v7/grantKey.js
async function grantKey_default3({ lockAddress, recipient, expiration, transactionOptions, keyManager }, callback) {
  const events = await grantKeys_default3.bind(this)({
    lockAddress,
    transactionOptions,
    recipients: [recipient],
    expirations: expiration ? [expiration] : [],
    keyManagers: keyManager ? [keyManager] : []
  }, callback);
  if (events == null ? void 0 : events.length) {
    return events[0];
  }
  return null;
}

// src/PublicLock/v7/isLockManager.js
async function isLockManager_default3(lockAddres, userAddress, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  return lockContract.isLockManager(userAddress);
}

// src/PublicLock/v7/isKeyGranter.js
async function isKeyGranter_default(lockAddress, address, provider) {
  const lockContract = await this.getLockContract(lockAddress, provider);
  return lockContract.isKeyGranter(address);
}

// src/PublicLock/v7/addKeyGranter.js
async function addKeyGranter_default({ lockAddress, keyGranter }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.addKeyGranter(keyGranter);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  await this.provider.waitForTransaction(hash);
  return true;
}

// src/PublicLock/v7/expireAndRefundFor.js
async function expireAndRefundFor_default({ lockAddress, keyOwner, amount = "0", decimals, erc20Address }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address || erc20Address !== ZERO) {
    erc20Address = await lockContract.tokenAddress();
  }
  if (decimals == null) {
    if (erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
  }
  const actualAmount = utils_default.toDecimal(amount, decimals);
  const transactionPromise = lockContract.expireAndRefundFor(keyOwner, actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v7/cancelAndRefund.js
async function cancelAndRefund_default3({ lockAddress, tokenId }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!tokenId) {
    const owner = await this.signer.getAddress();
    tokenId = await lockContract.getTokenIdFor(owner);
  }
  const transactionPromise = lockContract.cancelAndRefund(tokenId);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v7/keyManagerOf.js
async function keyManagerOf_default(lockAddres, tokenId, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  return lockContract.keyManagerOf(tokenId);
}

// src/PublicLock/v7/getCancelAndRefundValueFor.js
async function getCancelAndRefundValueFor({
  lockAddress,
  owner,
  tokenAddress
}) {
  const lockContract = await this.getLockContract(lockAddress);
  const value = await lockContract.getCancelAndRefundValueFor(owner);
  let refundValue;
  if (tokenAddress === ZERO) {
    refundValue = utils_default.fromWei(value, "ether");
  } else {
    refundValue = await getErc20Decimals(tokenAddress, this.provider);
  }
  return refundValue;
}
var getCancelAndRefundValueFor_default = getCancelAndRefundValueFor;

// src/PublicLock/v7/index.js
var {
  shareKey,
  initializeTemplate,
  withdrawFromLock,
  updateKeyPrice,
  purchaseKey,
  purchaseKeys,
  getLock,
  getTokenIdForOwner: getTokenIdForOwner2,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner2,
  totalKeys: totalKeys2
} = v6_default;
var v7_default = {
  version: "v7",
  Unlock: abis_default.Unlock.v7,
  PublicLock: abis_default.PublicLock.v7,
  initializeTemplate,
  updateKeyPrice,
  purchaseKey,
  purchaseKeys,
  getLock,
  grantKey: grantKey_default3,
  grantKeys: grantKeys_default3,
  withdrawFromLock,
  isLockManager: isLockManager_default3,
  isKeyGranter: isKeyGranter_default,
  addKeyGranter: addKeyGranter_default,
  expireAndRefundFor: expireAndRefundFor_default,
  cancelAndRefund: cancelAndRefund_default3,
  shareKey,
  keyManagerOf: keyManagerOf_default,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor_default,
  getTokenIdForOwner: getTokenIdForOwner2,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner2,
  totalKeys: totalKeys2
};

// src/PublicLock/v8/keyManagerOf.js
async function keyManagerOf_default2(lockAddres, tokenId, provider) {
  const lockContract = await this.getLockContract(lockAddres, provider);
  return lockContract.keyManagerOf(tokenId);
}

// src/PublicLock/v8/approveBeneficiary.js
async function approveBeneficiary_default({ lockAddress, spender, amount = "0", decimals, erc20Address }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address || erc20Address !== ZERO) {
    erc20Address = await lockContract.tokenAddress();
  }
  if (erc20Address === ZERO) {
    throw new Error("Lock can only set approval for ERC20");
  }
  let actualAmount;
  if (amount !== MAX_UINT) {
    if (decimals == null) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    }
    actualAmount = utils_default.toDecimal(amount, decimals);
  } else {
    actualAmount = amount;
  }
  const transactionPromise = lockContract.approveBeneficiary(spender, actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v8/index.js
var {
  grantKey,
  grantKeys,
  updateKeyPrice: updateKeyPrice2,
  withdrawFromLock: withdrawFromLock2,
  initializeTemplate: initializeTemplate2,
  isLockManager,
  isKeyGranter,
  addKeyGranter,
  expireAndRefundFor,
  cancelAndRefund,
  shareKey: shareKey2,
  getLock: getLock2,
  purchaseKey: purchaseKey2,
  purchaseKeys: purchaseKeys2,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor2,
  getTokenIdForOwner: getTokenIdForOwner3,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner3,
  totalKeys: totalKeys3
} = v7_default;
var v8_default = {
  version: "v8",
  Unlock: abis_default.Unlock.v8,
  PublicLock: abis_default.PublicLock.v8,
  initializeTemplate: initializeTemplate2,
  updateKeyPrice: updateKeyPrice2,
  purchaseKey: purchaseKey2,
  purchaseKeys: purchaseKeys2,
  grantKey,
  grantKeys,
  getLock: getLock2,
  withdrawFromLock: withdrawFromLock2,
  isLockManager,
  isKeyGranter,
  addKeyGranter,
  expireAndRefundFor,
  cancelAndRefund,
  shareKey: shareKey2,
  keyManagerOf: keyManagerOf_default2,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor2,
  getTokenIdForOwner: getTokenIdForOwner3,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner3,
  approveBeneficiary: approveBeneficiary_default,
  totalKeys: totalKeys3
};

// src/PublicLock/v9/purchaseKey.js
async function purchaseKey_default3({
  lockAddress,
  owner,
  keyManager,
  keyPrice,
  erc20Address,
  decimals,
  referrer,
  data
}, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!owner) {
    owner = await this.signer.getAddress();
  }
  if (!referrer) {
    referrer = ZERO;
  }
  if (!keyManager) {
    keyManager = ZERO;
  }
  if (!data) {
    data = [];
  }
  if (!erc20Address) {
    erc20Address = await lockContract.tokenAddress();
  }
  let actualAmount;
  if (!keyPrice) {
    actualAmount = await lockContract.keyPrice();
  } else {
    actualAmount = await formatKeyPrice_default(keyPrice, erc20Address, decimals, this.provider);
  }
  const purchaseForOptions = {};
  if (erc20Address && erc20Address !== ZERO) {
    const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
    if (!approvedAmount || approvedAmount.lt(actualAmount)) {
      await (await approveTransfer(erc20Address, lockAddress, actualAmount, this.provider, this.signer)).wait();
    }
  } else {
    purchaseForOptions.value = actualAmount;
  }
  if (!purchaseForOptions.gasLimit) {
    try {
      const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = await this.provider.getFeeData();
      if (maxFeePerGas && maxPriorityFeePerGas) {
        purchaseForOptions.maxFeePerGas = maxFeePerGas;
        purchaseForOptions.maxPriorityFeePerGas = maxPriorityFeePerGas;
      } else {
        purchaseForOptions.gasPrice = gasPrice;
      }
      const gasLimit = await lockContract.estimateGas.purchase(actualAmount, owner, referrer, keyManager, data, purchaseForOptions);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
      purchaseForOptions.gasLimit = gasLimit.mul(13).div(10).toNumber();
    } catch (error) {
      console.error("We could not estimate gas ourselves. Let wallet do it.", error);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
    }
  }
  const transactionPromise = lockContract.purchase(actualAmount, owner, referrer, keyManager, data, purchaseForOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  if (receipt.status === 0) {
    throw new Error("Transaction failed");
  }
  const parser = lockContract.interface;
  const transferEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  })[0];
  if (transferEvent) {
    return transferEvent.args.tokenId.toString();
  }
  return null;
}

// src/PublicLock/v9/purchaseKeys.js
async function purchaseKeys_default3(params, callback) {
  return await multiplePurchaseWrapper_default.bind(this)(purchaseKey_default3, params, callback);
}

// src/PublicLock/v9/setMaxNumberOfKeys.js
async function setMaxNumberOfKeys({ lockAddress, maxNumberOfKeys }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.setMaxNumberOfKeys(maxNumberOfKeys);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  await this.provider.waitForTransaction(hash);
}
var setMaxNumberOfKeys_default = setMaxNumberOfKeys;

// src/PublicLock/v9/setExpirationDuration.js
async function setExpirationDuration({ lockAddress, expirationDuration }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.setExpirationDuration(expirationDuration);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  await this.provider.waitForTransaction(hash);
}
var setExpirationDuration_default = setExpirationDuration;

// src/PublicLock/v9/index.js
var {
  grantKey: grantKey2,
  grantKeys: grantKeys2,
  updateKeyPrice: updateKeyPrice3,
  withdrawFromLock: withdrawFromLock3,
  initializeTemplate: initializeTemplate3,
  isLockManager: isLockManager2,
  isKeyGranter: isKeyGranter2,
  addKeyGranter: addKeyGranter2,
  expireAndRefundFor: expireAndRefundFor2,
  cancelAndRefund: cancelAndRefund2,
  shareKey: shareKey3,
  getLock: getLock3,
  keyManagerOf,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor3,
  getTokenIdForOwner: getTokenIdForOwner4,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner4,
  approveBeneficiary,
  totalKeys: totalKeys4
} = v8_default;
var v9_default = {
  version: "v9",
  Unlock: abis_default.Unlock.v9,
  PublicLock: abis_default.PublicLock.v9,
  grantKey: grantKey2,
  grantKeys: grantKeys2,
  updateKeyPrice: updateKeyPrice3,
  withdrawFromLock: withdrawFromLock3,
  initializeTemplate: initializeTemplate3,
  isLockManager: isLockManager2,
  isKeyGranter: isKeyGranter2,
  addKeyGranter: addKeyGranter2,
  expireAndRefundFor: expireAndRefundFor2,
  cancelAndRefund: cancelAndRefund2,
  shareKey: shareKey3,
  getLock: getLock3,
  purchaseKey: purchaseKey_default3,
  purchaseKeys: purchaseKeys_default3,
  keyManagerOf,
  setMaxNumberOfKeys: setMaxNumberOfKeys_default,
  setExpirationDuration: setExpirationDuration_default,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor3,
  getTokenIdForOwner: getTokenIdForOwner4,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner4,
  approveBeneficiary,
  totalKeys: totalKeys4
};

// src/PublicLock/v10/purchaseKeys.js
async function purchaseKeys_default4({
  owners: _owners,
  keyManagers: _keyManagers,
  keyPrices: _keyPrices,
  referrers: _referrers,
  lockAddress,
  erc20Address,
  recurringPayments,
  decimals,
  data: _data
}, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address) {
    erc20Address = await lockContract.tokenAddress();
  }
  const defaultOwner = await this.signer.getAddress();
  const owners = _owners || [defaultOwner];
  const defaultArray = Array(owners.length).fill(null);
  const keyPrices = await Promise.all((_keyPrices || defaultArray).map(async (kp) => {
    if (!kp) {
      return await lockContract.keyPrice();
    }
    return formatKeyPrice_default(kp, erc20Address, decimals, this.provider);
  }));
  const keyManagers = (_keyManagers || defaultArray).map((km) => km || ZERO);
  const referrers = (_referrers || defaultArray).map((km) => km || ZERO);
  const data = (_data || defaultArray).map((d) => d || []);
  if (!(keyManagers.length === owners.length && keyPrices.length === owners.length && referrers.length === owners.length && data.length === owners.length)) {
    throw new Error("Params mismatch. All purchaseKeys params array should have the same length");
  }
  const totalPrice = keyPrices.reduce((total, kp) => total.add(kp), utils_default.bigNumberify(0));
  if (erc20Address && erc20Address !== ZERO) {
    const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
    const totalAmountToApprove = recurringPayments ? keyPrices.map((kp, i) => kp.mul(recurringPayments[i])).reduce((total, approval) => total.add(approval), utils_default.bigNumberify(0)) : totalPrice;
    if (!approvedAmount || utils_default.bigNumberify(approvedAmount).lt(totalAmountToApprove)) {
      await (await approveTransfer(erc20Address, lockAddress, totalAmountToApprove, this.provider, this.signer)).wait();
    }
  }
  const purchaseForOptions = {};
  if (!erc20Address || erc20Address === ZERO) {
    purchaseForOptions.value = totalPrice;
  }
  if (!purchaseForOptions.gasLimit) {
    try {
      const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = await this.provider.getFeeData();
      if (maxFeePerGas && maxPriorityFeePerGas) {
        purchaseForOptions.maxFeePerGas = maxFeePerGas;
        purchaseForOptions.maxPriorityFeePerGas = maxPriorityFeePerGas;
      } else {
        purchaseForOptions.gasPrice = gasPrice;
      }
      const gasLimit = await lockContract.estimateGas.purchase(keyPrices, owners, referrers, keyManagers, data, purchaseForOptions);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
      purchaseForOptions.gasLimit = gasLimit.mul(13).div(10).toNumber();
    } catch (error) {
      console.error("We could not estimate gas ourselves. Let wallet do it.", error);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
    }
  }
  const transactionPromise = lockContract.purchase(keyPrices, owners, referrers, keyManagers, data, purchaseForOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  if (receipt.status === 0) {
    throw new Error("Transaction failed");
  }
  const parser = lockContract.interface;
  const transferEvents = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  });
  if (transferEvents && transferEvents.length) {
    return transferEvents.map((v) => v.args.tokenId.toString());
  }
  return null;
}

// src/PublicLock/v10/purchaseKey.js
async function purchaseKey_default4({
  lockAddress,
  owner,
  keyManager,
  keyPrice,
  erc20Address,
  decimals,
  referrer,
  recurringPayments,
  data
}, callback) {
  const keys = await purchaseKeys_default4.bind(this)({
    owners: owner ? [owner] : null,
    keyManagers: keyManager ? [keyManager] : null,
    keyPrices: keyPrice ? [keyPrice] : null,
    referrers: referrer ? [referrer] : null,
    data: data ? [data] : null,
    recurringPayments: recurringPayments ? [recurringPayments] : null,
    lockAddress,
    erc20Address,
    decimals
  }, callback);
  return keys[0];
}

// src/PublicLock/v10/extendKey.js
async function extendKey_default({ lockAddress, tokenId, keyPrice, erc20Address, decimals, referrer, data }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!tokenId) {
    throw new Error("Missing tokenId.");
  }
  if (!referrer) {
    referrer = ZERO;
  }
  if (!data) {
    data = [];
  }
  if (!erc20Address) {
    erc20Address = await lockContract.tokenAddress();
  }
  let actualAmount;
  if (!keyPrice) {
    actualAmount = await lockContract.keyPrice();
  } else {
    actualAmount = await formatKeyPrice_default(keyPrice, erc20Address, decimals, this.provider);
  }
  const purchaseForOptions = {};
  if (erc20Address && erc20Address !== ZERO) {
    const approvedAmount = await getAllowance(erc20Address, lockAddress, this.provider, this.signer.address);
    if (!approvedAmount || approvedAmount.lt(actualAmount)) {
      await (await approveTransfer(erc20Address, lockAddress, actualAmount, this.provider, this.signer)).wait();
    }
  } else {
    purchaseForOptions.value = actualAmount;
  }
  if (!purchaseForOptions.gasLimit) {
    try {
      const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = await this.provider.getFeeData();
      if (maxFeePerGas && maxPriorityFeePerGas) {
        purchaseForOptions.maxFeePerGas = maxFeePerGas;
        purchaseForOptions.maxPriorityFeePerGas = maxPriorityFeePerGas;
      } else {
        purchaseForOptions.gasPrice = gasPrice;
      }
      const gasLimit = await lockContract.estimateGas.extend(actualAmount, tokenId, referrer, data, purchaseForOptions);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
      purchaseForOptions.gasLimit = gasLimit.mul(13).div(10).toNumber();
    } catch (error) {
      console.error("We could not estimate gas ourselves. Let wallet do it.", error);
      delete purchaseForOptions.maxFeePerGas;
      delete purchaseForOptions.maxPriorityFeePerGas;
      delete purchaseForOptions.gasPrice;
    }
  }
  const transactionPromise = lockContract.extend(actualAmount, tokenId, referrer, data, purchaseForOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  await this.provider.waitForTransaction(hash);
}

// src/PublicLock/v10/mergeKeys.js
async function mergeKeys_default({ lockAddress, tokenIdFrom, tokenIdTo, amount }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!tokenIdFrom) {
    throw new Error("Missing tokenId from");
  }
  if (!tokenIdTo) {
    throw new Error("Missing tokenId to");
  }
  if (!amount) {
    const blockNumber = await this.provider.getBlockNumber();
    const { timestamp } = await this.provider.getBlock(blockNumber);
    const expiration = await lockContract.keyExpirationTimestampFor(tokenIdFrom);
    amount = utils_default.bigNumberify(expiration).sub(timestamp + 3);
  }
  const transactionPromise = lockContract.mergeKeys(tokenIdFrom, tokenIdTo, amount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v10/shareKey.js
async function shareKey_default2({ lockAddress, tokenId, recipient, duration }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!tokenId) {
    throw new Error("shareKey: Missing token id from");
  }
  if (!duration) {
    const expiration = await lockContract.keyExpirationTimestampFor(tokenId);
    duration = Math.floor(new Date().getTime() / 1e3) - expiration.toNumber();
  }
  const transactionOptions = {};
  const transactionPromise = lockContract.shareKey(recipient, tokenId, duration, transactionOptions);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  if (receipt.status === 0) {
    throw new Error("Transaction failed");
  }
  const parser = lockContract.interface;
  const transferEvent = receipt.logs.map((log) => {
    if (log.address !== lockAddress)
      return;
    return parser.parseLog(log);
  }).filter((event) => {
    return event && event.name === "Transfer";
  })[0];
  if (transferEvent) {
    return transferEvent.args.tokenId.toString();
  }
  return null;
}

// src/PublicLock/v10/setMaxKeysPerAddress.js
async function setMaxKeysPerAddress_default({ lockAddress, maxKeysPerAddress }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.setMaxKeysPerAddress(maxKeysPerAddress);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  await this.provider.waitForTransaction(hash);
}

// src/PublicLock/v10/expireAndRefundFor.js
async function expireAndRefundFor_default2({ lockAddress, tokenId, amount = "0", decimals, erc20Address }, callback) {
  const lockContract = await this.getLockContract(lockAddress);
  if (!erc20Address || erc20Address !== ZERO) {
    erc20Address = await lockContract.tokenAddress();
  }
  if (decimals == null) {
    if (erc20Address !== ZERO) {
      decimals = await getErc20Decimals(erc20Address, this.provider);
    } else {
      decimals = 18;
    }
  }
  const actualAmount = utils_default.toDecimal(amount, decimals);
  const transactionPromise = lockContract.expireAndRefundFor(tokenId, actualAmount);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v10/getTokenIdForOwner.js
async function getTokenIdForOwner_default2(lockAddress, owner, network) {
  const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
  const validTokens = [];
  const allTokens = [];
  const balanceOfTokens = (await lockContract.balanceOf(owner)).toNumber();
  let i = 0;
  while (i < balanceOfTokens) {
    let tokenId = (await lockContract.tokenOfOwnerByIndex(owner, i)).toNumber();
    if (tokenId) {
      allTokens.push(tokenId);
      let expiration = await lockContract.keyExpirationTimestampFor(tokenId);
      if (expiration > new Date().getTime() * 1e3) {
        validTokens.push(tokenId);
      }
    }
    i++;
  }
  return validTokens[0] || allTokens[0] || 0;
}

// src/PublicLock/v10/getKeyExpirationByLockForOwner.js
async function getKeyExpirationByLockForOwner_default2(lockAddress, owner, network) {
  const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
  const tokenId = await getTokenIdForOwner_default2.bind(this)(lockAddress, owner, network);
  const expiration = await lockContract.keyExpirationTimestampFor(tokenId);
  if (expiration.eq(ETHERS_MAX_UINT)) {
    return -1;
  }
  return parseInt(expiration, 10);
}

// src/PublicLock/v10/getCancelAndRefundValueFor.js
async function getCancelAndRefundValueFor4({
  lockAddress,
  tokenAddress,
  tokenId
}) {
  const lockContract = await this.getLockContract(lockAddress);
  const value = await lockContract.getCancelAndRefundValue(tokenId);
  let refundValue;
  if (tokenAddress === ZERO) {
    refundValue = utils_default.fromWei(value, "ether");
  } else {
    refundValue = await getErc20Decimals(tokenAddress, this.provider);
  }
  return refundValue;
}
var getCancelAndRefundValueFor_default2 = getCancelAndRefundValueFor4;

// src/PublicLock/v10/getLock.js
async function getLock_default3(address, provider) {
  const update = await parseLockGetters_default.bind(this)(address, provider);
  if (update.currencyContractAddress) {
    const erc20LockAllowance = await getAllowance(update.currencyContractAddress, address, provider, address);
    update.selfAllowance = erc20LockAllowance.toString();
  }
  return update;
}

// src/PublicLock/v10/index.js
var {
  grantKey: grantKey3,
  grantKeys: grantKeys3,
  updateKeyPrice: updateKeyPrice4,
  withdrawFromLock: withdrawFromLock4,
  initializeTemplate: initializeTemplate4,
  isLockManager: isLockManager3,
  isKeyGranter: isKeyGranter3,
  addKeyGranter: addKeyGranter3,
  cancelAndRefund: cancelAndRefund3,
  keyManagerOf: keyManagerOf2,
  setMaxNumberOfKeys: setMaxNumberOfKeys2,
  setExpirationDuration: setExpirationDuration2,
  approveBeneficiary: approveBeneficiary2,
  totalKeys: totalKeys5
} = v9_default;
var v10_default = {
  version: "v10",
  PublicLock: abis_default.PublicLock.v10,
  grantKey: grantKey3,
  grantKeys: grantKeys3,
  extendKey: extendKey_default,
  updateKeyPrice: updateKeyPrice4,
  withdrawFromLock: withdrawFromLock4,
  initializeTemplate: initializeTemplate4,
  isLockManager: isLockManager3,
  isKeyGranter: isKeyGranter3,
  addKeyGranter: addKeyGranter3,
  expireAndRefundFor: expireAndRefundFor_default2,
  cancelAndRefund: cancelAndRefund3,
  shareKey: shareKey_default2,
  getLock: getLock_default3,
  purchaseKey: purchaseKey_default4,
  purchaseKeys: purchaseKeys_default4,
  mergeKeys: mergeKeys_default,
  keyManagerOf: keyManagerOf2,
  setMaxNumberOfKeys: setMaxNumberOfKeys2,
  setExpirationDuration: setExpirationDuration2,
  setMaxKeysPerAddress: setMaxKeysPerAddress_default,
  getTokenIdForOwner: getTokenIdForOwner_default2,
  getKeyExpirationByLockForOwner: getKeyExpirationByLockForOwner_default2,
  getCancelAndRefundValueFor: getCancelAndRefundValueFor_default2,
  approveBeneficiary: approveBeneficiary2,
  totalKeys: totalKeys5
};

// src/PublicLock/v11/grantKeyExtension.js
async function grantKeyExtension_default({ lockAddress, tokenId, duration = 0 }, callback) {
  if (!tokenId) {
    throw new Error("Missing tokenId.");
  }
  const lockContract = await this.getLockContract(lockAddress);
  const transactionPromise = lockContract.grantKeyExtension(tokenId, duration);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash);
  }
  await this.provider.waitForTransaction(hash);
  return null;
}

// src/PublicLock/v11/index.js
var v11_default = __spreadProps(__spreadValues({}, v10_default), {
  grantKeyExtension: grantKeyExtension_default,
  version: "v11",
  PublicLock: abis_default.PublicLock.v11
});

// src/PublicLock/index.ts
var PublicLock_default = {
  v4: v4_default,
  v6: v6_default,
  v7: v7_default,
  v8: v8_default,
  v9: v9_default,
  v10: v10_default,
  v11: v11_default
};

// src/Unlock/v4/createLock.js
async function _getKeyPrice(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default(lock, callback) {
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = _getKeyPrice(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name || "New Lock";
  const transactionPromise = unlockContract.functions["createLock(uint256,address,uint256,uint256,string)"](lock.expirationDuration, currencyContractAddress, decimalKeyPrice, maxNumberOfKeys, lockName);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = receipt.logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.signature === "NewLock(address,address)")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v4/index.js
var v4_default2 = {
  createLock: createLock_default,
  version: "v4",
  Unlock: abis_default.Unlock.v4,
  PublicLock: abis_default.PublicLock.v4
};

// src/Unlock/v6/createLock.js
async function _getKeyPrice2(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default2(lock, callback) {
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = await _getKeyPrice2(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name;
  const salt = utils_default.sha3(utils_default.utf8ToHex(lock.name)).substring(0, 26);
  const transactionPromise = unlockContract.createLock(lock.expirationDuration, currencyContractAddress, decimalKeyPrice, maxNumberOfKeys, lockName, salt);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = receipt.logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.name === "NewLock")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v6/index.js
var v6_default2 = {
  createLock: createLock_default2,
  version: "v6",
  Unlock: abis_default.Unlock.v6,
  PublicLock: abis_default.PublicLock.v6
};

// src/Unlock/v7/createLock.js
async function _getKeyPrice3(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default3(lock, callback) {
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = await _getKeyPrice3(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name;
  const salt = utils_default.sha3(utils_default.utf8ToHex(lock.name)).substring(0, 26);
  const transactionPromise = unlockContract.createLock(lock.expirationDuration, currencyContractAddress, decimalKeyPrice, maxNumberOfKeys, lockName, salt);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = receipt.logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.name === "NewLock")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v7/index.js
var v7_default2 = {
  createLock: createLock_default3,
  version: "v7",
  Unlock: abis_default.Unlock.v7,
  PublicLock: abis_default.PublicLock.v7
};

// src/Unlock/v8/createLock.js
async function _getKeyPrice4(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default4(lock, callback) {
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = await _getKeyPrice4(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name;
  const salt = utils_default.sha3(utils_default.utf8ToHex(lock.name)).substring(0, 26);
  const transactionPromise = unlockContract.createLock(lock.expirationDuration, currencyContractAddress, decimalKeyPrice, maxNumberOfKeys, lockName, salt);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = receipt.logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.name === "NewLock")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v8/index.js
var v8_default2 = {
  createLock: createLock_default4,
  version: "v8",
  Unlock: abis_default.Unlock.v8,
  PublicLock: abis_default.PublicLock.v8
};

// src/Unlock/v9/index.js
var { createLock } = v8_default2;
var v9_default2 = {
  createLock,
  version: "v9",
  Unlock: abis_default.Unlock.v9,
  PublicLock: abis_default.PublicLock.v9
};

// src/Unlock/v10/upgradeLock.js
async function upgradeLock_default(lockAddress, lockVersion, callback) {
  if (typeof lockVersion !== "number")
    throw Error("lockVersion should be a number");
  const unlockContract = await this.getUnlockContract();
  const transactionPromise = unlockContract.upgradeLock(lockAddress, lockVersion);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const receipt = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const upgradeLockEvent = receipt.logs.map((log) => {
    return parser.parseLog(log);
  }).filter((event) => event.name === "UpgradeLock")[0];
  if (upgradeLockEvent) {
    return upgradeLockEvent.args.version;
  }
  return null;
}

// src/Unlock/v10/createLock.js
async function _getKeyPrice5(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default5(lock, callback) {
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys, expirationDuration } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  if (expirationDuration === -1) {
    expirationDuration = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = await _getKeyPrice5(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name;
  const salt = utils_default.sha3(utils_default.utf8ToHex(lock.name)).substring(0, 26);
  const transactionPromise = unlockContract.createLock(expirationDuration, currencyContractAddress, decimalKeyPrice, maxNumberOfKeys, lockName, salt);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const { logs } = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.name === "NewLock")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v10/index.js
var v10_default2 = {
  createLock: createLock_default5,
  upgradeLock: upgradeLock_default,
  version: "v10",
  Unlock: abis_default.Unlock.v10
};

// src/Unlock/v11/createLock.js
import { ethers as ethers4 } from "ethers";
async function _getKeyPrice6(lock, provider) {
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  if (currencyContractAddress !== ZERO) {
    const erc20Decimals = await getErc20Decimals(currencyContractAddress, provider);
    return utils_default.toDecimal(lock.keyPrice, erc20Decimals);
  }
  return utils_default.toWei(lock.keyPrice, "ether");
}
async function createLock_default6(lock, callback) {
  const lockVersion = lock.publicLockVersion || 9;
  const unlockContract = await this.getUnlockContract();
  let { maxNumberOfKeys, expirationDuration } = lock;
  if (maxNumberOfKeys === UNLIMITED_KEYS_COUNT) {
    maxNumberOfKeys = ETHERS_MAX_UINT;
  }
  if (expirationDuration === -1) {
    expirationDuration = ETHERS_MAX_UINT;
  }
  const decimalKeyPrice = await _getKeyPrice6(lock, this.provider);
  const currencyContractAddress = lock.currencyContractAddress || ZERO;
  const lockName = lock.name;
  const lockCreator = await this.signer.getAddress();
  if (!lockCreator) {
    throw new Error("No signer detected");
  }
  const { abi: lockAbi } = abis_default.PublicLock[`v${lockVersion}`];
  const lockInterface = new ethers4.utils.Interface(lockAbi);
  const calldata = lockInterface.encodeFunctionData("initialize(address,uint256,address,uint256,uint256,string)", [
    lockCreator,
    expirationDuration,
    currencyContractAddress,
    decimalKeyPrice,
    maxNumberOfKeys,
    lockName
  ]);
  const transactionPromise = unlockContract.createUpgradeableLockAtVersion(calldata, lockVersion);
  const hash = await this._handleMethodCall(transactionPromise);
  if (callback) {
    callback(null, hash, await transactionPromise);
  }
  const { logs } = await this.provider.waitForTransaction(hash);
  const parser = unlockContract.interface;
  const newLockEvent = logs.map((log) => {
    try {
      return parser.parseLog(log);
    } catch {
      return {};
    }
  }).filter((event) => event.name === "NewLock")[0];
  if (newLockEvent) {
    return newLockEvent.args.newLockAddress;
  }
  return null;
}

// src/Unlock/v11/index.js
var v11_default2 = {
  createLock: createLock_default6,
  version: "v11",
  Unlock: abis_default.Unlock.v11
};

// src/Unlock/index.ts
var Unlock_default = {
  v4: v4_default2,
  v6: v6_default2,
  v7: v7_default2,
  v8: v8_default2,
  v9: v9_default2,
  v10: v10_default2,
  v11: v11_default2
};

// src/unlockService.ts
var UnlockService = class {
  constructor(networks) {
    this.networks = networks;
    this.versionForAddress = {};
  }
  providerForNetwork(networkId) {
    if (!this.networks[networkId]) {
      throw new Error(`Missing config for ${networkId}`);
    }
    if (this.networks[networkId].ethersProvider) {
      return this.networks[networkId].ethersProvider;
    }
    return new ethers5.providers.JsonRpcProvider(this.networks[networkId].provider, networkId);
  }
  async isUnlockContractDeployed(network) {
    if (!this.networks[network]) {
      throw new Error(`Missing config for ${network}`);
    }
    let opCode = await this.providerForNetwork(network).getCode(this.networks[network].unlockAddress);
    return opCode !== "0x";
  }
  async contractAbiVersion(address, versionRetrievalMethodName, provider) {
    const contractAddress = address.toLowerCase();
    let version = this.versionForAddress[contractAddress];
    if (version === void 0) {
      version = await this[versionRetrievalMethodName](contractAddress, provider);
      this.versionForAddress[contractAddress] = version;
    }
    const contractName = versionRetrievalMethodName.includes("PublicLock") ? "PublicLock" : "Unlock";
    if (contractName === "PublicLock") {
      return PublicLock_default[`v${version}`];
    }
    if (contractName === "Unlock") {
      return Unlock_default[`v${version}`];
    }
    throw new Error(`Contract ${address} not deployed, or unknown version ${version}`);
  }
  async unlockContractAbiVersion(address, provider) {
    return this.contractAbiVersion(address, "_getUnlockVersionFromContract", provider);
  }
  async lockContractAbiVersion(address, provider) {
    return this.contractAbiVersion(address, "_getPublicLockVersionFromContract", provider);
  }
  async _getPublicLockVersionFromContract(address, provider) {
    const contract = new ethers5.Contract(address, ["function publicLockVersion() view returns (uint8)"], provider);
    let version = 0;
    try {
      const contractVersion = await contract.publicLockVersion();
      version = parseInt(contractVersion, 10) || 0;
    } catch (error) {
      console.error(`We could not retrieve the version of the Unlock contract ${address} on this network.`);
    }
    return version;
  }
  async _getUnlockVersionFromContract(address, provider) {
    const contract = new ethers5.Contract(address, ["function unlockVersion() view returns (uint8)"], provider);
    let version = 0;
    try {
      const contractVersion = await contract.unlockVersion();
      version = parseInt(contractVersion, 10) || 0;
    } catch (error) {
      const opCode = await provider.getCode(address);
      const hash = ethers5.utils.sha256(opCode);
      if (hash === "0x886b9da11c0a665e98fd914bc79908925a4f6a549286de92ee6825e441a26309") {
        version = 1;
      }
    }
    return version;
  }
  getContract(address, contract, provider) {
    return new ethers5.Contract(address, contract.abi, provider);
  }
  async getLockContract(lockAddress, provider) {
    const version = await this.lockContractAbiVersion(lockAddress, provider);
    return this.getContract(lockAddress, version.PublicLock, provider);
  }
  async getUnlockContract(unlockAddress, provider) {
    const version = await this.unlockContractAbiVersion(unlockAddress, provider);
    return this.getContract(unlockAddress, version.Unlock, provider);
  }
};

// src/web3Service.ts
var Web3Service = class extends UnlockService {
  _create2Address(unlockAddress, templateAddress, account, lockSalt) {
    const saltHex = `${account}${lockSalt}`;
    const byteCode = `0x3d602d80600a3d3981f3363d3d373d3d3d363d73${templateAddress.replace(/0x/, "")}5af43d82803e903d91602b57fd5bf3`;
    const byteCodeHash = utils_default.sha3(byteCode);
    const seed = ["ff", unlockAddress, saltHex, byteCodeHash].map((x) => x.replace(/0x/, "")).join("");
    const address = utils_default.sha3(`0x${seed}`).slice(-40);
    return utils_default.toChecksumAddress(`0x${address}`);
  }
  async getTransaction(hash, network) {
    return await this.providerForNetwork(network).getTransaction(hash);
  }
  async getAddressBalance(address, network) {
    const balance = await this.providerForNetwork(network).getBalance(address);
    return utils_default.fromWei(balance, "ether");
  }
  async getLock(address, network) {
    const version = await this.lockContractAbiVersion(address, this.providerForNetwork(network));
    const lock = await version.getLock.bind(this)(address, this.providerForNetwork(network));
    lock.address = address;
    return lock;
  }
  async isLockManager(lockAddress, manager, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    if (!version.isLockManager) {
      throw new Error("Lock version not supported");
    }
    return version.isLockManager.bind(this)(lockAddress, manager, this.providerForNetwork(network));
  }
  async getKeyByTokenId(lockAddress, tokenId, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    if (await lockContract.publicLockVersion() < 10) {
      throw new Error("Only available for Lock v10+");
    }
    const expiration = await this.getKeyExpirationByTokenId(lockAddress, tokenId, network);
    const owner = await this.ownerOf(lockAddress, tokenId, network);
    const keyPayload = {
      tokenId,
      lock: lockAddress,
      owner,
      expiration
    };
    return keyPayload;
  }
  async getKeyExpirationByTokenId(lockAddress, tokenId, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    if (await lockContract.publicLockVersion() < 10) {
      throw new Error("Only available for Lock v10+");
    }
    try {
      const expiration = await lockContract.keyExpirationTimestampFor(tokenId);
      if (expiration == "3963877391197344453575983046348115674221700746820753546331534351508065746944") {
        return 0;
      }
      if (expiration.eq(ETHERS_MAX_UINT)) {
        return -1;
      }
      return parseInt(expiration, 10);
    } catch (error) {
      return 0;
    }
  }
  async getKeyByLockForOwner(lockAddress, owner, network) {
    const keyPayload = {
      lock: lockAddress,
      owner,
      expiration: 0,
      tokenId: 0
    };
    keyPayload.tokenId = await this.getTokenIdForOwner(lockAddress, owner, network);
    keyPayload.expiration = await this.getKeyExpirationByLockForOwner(lockAddress, owner, network);
    return keyPayload;
  }
  async getHasValidKey(lockAddress, owner, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return lockContract.getHasValidKey(owner);
  }
  async getKeyExpirationByLockForOwner(lockAddress, owner, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    return version.getKeyExpirationByLockForOwner.bind(this)(lockAddress, owner, network);
  }
  async getTokenIdForOwner(lockAddress, owner, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    return version.getTokenIdForOwner.bind(this)(lockAddress, owner, network);
  }
  async recoverAccountFromSignedData(data, signedData) {
    return utils_default.verifyMessage(data, signedData);
  }
  async getTokenSymbol(contractAddress, network) {
    const symbolPromise = getErc20TokenSymbol(contractAddress, this.providerForNetwork(network));
    return symbolPromise;
  }
  async getTokenBalance(contractAddress, userWalletAddress, network) {
    const balance = await getErc20BalanceForAddress(contractAddress, userWalletAddress, this.providerForNetwork(network));
    const decimals = await getErc20Decimals(contractAddress, this.providerForNetwork(network));
    return utils_default.fromDecimal(balance, decimals);
  }
  async getTokenDecimals(contractAddress, network) {
    const provider = this.providerForNetwork(network);
    const decimals = await getErc20Decimals(contractAddress, provider);
    return decimals;
  }
  async isKeyGranter(lockAddress, address, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    if (!version.isKeyGranter) {
      throw new Error("Lock version not supported");
    }
    return version.isKeyGranter.bind(this)(lockAddress, address, this.providerForNetwork(network));
  }
  async keyManagerOf(lockAddress, tokenId, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    if (!version.keyManagerOf) {
      throw new Error("Lock version not supported");
    }
    return version.keyManagerOf.bind(this)(lockAddress, tokenId, this.providerForNetwork(network));
  }
  async ownerOf(lockAddress, tokenId, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return lockContract.ownerOf(tokenId);
  }
  async isValidKey(lockAddress, tokenId, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return lockContract.isValidKey(tokenId);
  }
  async lockContract(lockAddress, network) {
    return await this.getLockContract(lockAddress, this.providerForNetwork(network));
  }
  async numberOfOwners(lockAddress, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return ethers6.BigNumber.from(await lockContract.numberOfOwners()).toNumber();
  }
  async totalKeys(lockAddress, owner, network) {
    const version = await this.lockContractAbiVersion(lockAddress, this.providerForNetwork(network));
    if (!version.totalKeys) {
      throw new Error("Lock version not supported");
    }
    return ethers6.BigNumber.from(await version.totalKeys.bind(this)(lockAddress, owner, this.providerForNetwork(network))).toNumber();
  }
  async publicLockVersion(lockAddress, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return await lockContract.publicLockVersion();
  }
  async tokenURI(lockAddress, tokenId, network) {
    const lockContract = await this.getLockContract(lockAddress, this.providerForNetwork(network));
    return await lockContract.tokenURI(tokenId);
  }
};

// src/walletService.ts
var WalletService = class extends UnlockService {
  async connect(provider, signer) {
    this.provider = provider;
    if (signer) {
      this.signer = signer;
    } else {
      this.signer = this.provider.getSigner(0);
    }
    const { chainId: networkId } = await this.provider.getNetwork();
    if (this.networkId !== networkId) {
      this.networkId = networkId;
    }
    if (!this.networks[networkId]) {
      throw new Error(`Missing config for ${networkId}`);
    }
    if (this.networks[networkId].unlockAddress) {
      this.unlockAddress = this.networks[networkId].unlockAddress;
    }
    return networkId;
  }
  async getAccount() {
    const accounts = await this.provider.listAccounts();
    if (!accounts.length) {
      return null;
    }
    const address = accounts[0];
    return address;
  }
  async _handleMethodCall(methodCall) {
    const transaction = await methodCall;
    if (transaction.hash) {
      return transaction.hash;
    }
    const finalTransaction = await transaction.wait();
    return finalTransaction.hash;
  }
  async updateKeyPrice(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.updateKeyPrice.bind(this)(params, callback);
  }
  async createLock(lock, callback) {
    const version = await this.unlockContractAbiVersion();
    if (lock && typeof lock.publicLockVersion !== "undefined" && version < 11) {
      throw new Error("Lock creation at version only available for lock v11+");
    }
    return version.createLock.bind(this)(lock, callback);
  }
  async unlockContractAbiVersion() {
    return super.unlockContractAbiVersion(this.unlockAddress, this.provider);
  }
  async lockContractAbiVersion(address) {
    return super.lockContractAbiVersion(address, this.provider);
  }
  async getUnlockContract() {
    const contract = await super.getUnlockContract(this.unlockAddress, this.provider);
    return contract.connect(this.signer);
  }
  async getLockContract(address) {
    const contract = await super.getLockContract(address, this.provider);
    return contract.connect(this.signer);
  }
  async initializeTemplate(params, callback) {
    if (!params.templateAddress)
      throw new Error("Missing templateAddress");
    const version = await this.lockContractAbiVersion(params.templateAddress);
    return version.initializeTemplate.bind(this)(params, callback);
  }
  async purchaseKey(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.purchaseKey.bind(this)(params, callback);
  }
  async purchaseKeys(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.purchaseKeys.bind(this)(params, callback);
  }
  async extendKey(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.cancelAndRefund) {
      throw new Error("Lock version not supported");
    }
    return version.extendKey.bind(this)(params, callback);
  }
  async mergeKeys(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.mergeKeys) {
      throw new Error("Lock version not supported");
    }
    return version.mergeKeys.bind(this)(params, callback);
  }
  async approveBeneficiary(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.approveBeneficiary) {
      throw new Error("Lock version not supported");
    }
    return version.approveBeneficiary.bind(this)(params, callback);
  }
  async addKeyGranter(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    if (!params.keyGranter)
      throw new Error("Missing account");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.addKeyGranter) {
      throw new Error("Lock version not supported");
    }
    return version.addKeyGranter.bind(this)(params, callback);
  }
  async expireAndRefundFor(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    if (!params.keyOwner)
      throw new Error("Missing keyOwner");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.expireAndRefundFor) {
      throw new Error("Lock version not supported");
    }
    return version.expireAndRefundFor.bind(this)(params, callback);
  }
  async cancelAndRefund(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.cancelAndRefund) {
      throw new Error("Lock version not supported");
    }
    return version.cancelAndRefund.bind(this)(params, callback);
  }
  async shareKey(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    if (!params.recipient)
      throw new Error("Missing recipient");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.shareKey) {
      throw new Error("Lock version not supported");
    }
    return version.shareKey.bind(this)(params, callback);
  }
  async grantKey(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.grantKey.bind(this)(params, callback);
  }
  async grantKeys(params, callback) {
    if (!params.lockAddress) {
      throw new Error("Missing lockAddress");
    }
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.grantKeys.bind(this)(params, callback);
  }
  async grantKeyExtension(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.grantKeyExtension) {
      throw new Error("Lock version not supported");
    }
    return version.grantKeyExtension.bind(this)(params, callback);
  }
  async withdrawFromLock(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    return version.withdrawFromLock.bind(this)(params, callback);
  }
  async unformattedSignTypedData(account, data) {
    const methods = {
      eth_signTypedData: (data2) => data2,
      eth_signTypedData_v3: (data2) => JSON.stringify(data2),
      eth_signTypedData_v4: (data2) => JSON.stringify(data2)
    };
    const toTry = Object.keys(methods);
    return new Promise((resolve, reject) => {
      const tryNext = async (tries) => {
        const method = tries.shift();
        if (!method) {
          return reject(new Error("All signing method failed"));
        }
        try {
          const sendData = methods[method](data);
          const result = await this.provider.send(method, [account, sendData]);
          if (result) {
            return resolve(result);
          }
        } catch (error) {
          console.error(`Method ${method} not supported by provider.`);
          console.error(error);
        }
        return tryNext(tries);
      };
      tryNext(toTry);
    });
  }
  async signMessage(data, method) {
    const dataHash = utils_default.utf8ToHex(data);
    const addr = await this.signer.getAddress();
    let firstParam = dataHash;
    let secondParam = addr.toLowerCase();
    if (method === "eth_sign") {
      ;
      [firstParam, secondParam] = [secondParam, firstParam];
    }
    return this.provider.send(method, [firstParam, secondParam]);
  }
  async signDataPersonal(account, data, callback) {
    try {
      let method = "eth_sign";
      if (this.web3Provider || this.provider.isUnlock) {
        method = "personal_sign";
      }
      const signature = await this.signMessage(data, method);
      callback(null, Buffer.from(signature).toString("base64"));
    } catch (error) {
      if (error instanceof Error) {
        callback(error, null);
      }
    }
  }
  async setMaxNumberOfKeys(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.setMaxNumberOfKeys) {
      throw new Error("Lock version not supported");
    }
    return version.setMaxNumberOfKeys.bind(this)(params, callback);
  }
  async setMaxKeysPerAddress(params, callback) {
    if (!params.lockAddress)
      throw new Error("Missing lockAddress");
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.setMaxKeysPerAddress) {
      throw new Error("Lock version not supported");
    }
    return version.setMaxKeysPerAddress.bind(this)(params, callback);
  }
  async setExpirationDuration(params, callback) {
    if (!params.lockAddress) {
      throw new Error("Missing lockAddress");
    }
    if (params.expirationDuration && params.expirationDuration < 1) {
      throw new Error("Expiration duration must be greater than 0");
    }
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.setExpirationDuration) {
      throw new Error("Lock version not supported");
    }
    return version.setExpirationDuration.bind(this)(params, callback);
  }
  async getCancelAndRefundValueFor(params, callback) {
    if (!params.lockAddress) {
      throw new Error("Missing lockAddress");
    }
    if (!params.owner) {
      throw new Error("Missing owner");
    }
    if (!params.tokenAddress) {
      throw new Error("Missing tokenAddress");
    }
    const version = await this.lockContractAbiVersion(params.lockAddress);
    if (!version.getCancelAndRefundValueFor) {
      throw new Error("Lock version not supported");
    }
    return version.getCancelAndRefundValueFor.bind(this)(params, callback);
  }
};

// src/providers.ts
function getCurrentProvider(environment) {
  if (environment.ethereum && environment.ethereum.constructor.name === "Object")
    return "Opera";
  if (environment.web3.currentProvider.isMetaMask)
    return "Metamask";
  if (environment.web3.currentProvider.isTrust)
    return "Trust";
  if (environment.web3.currentProvider.isToshi)
    return "Coinbase Wallet";
  if (environment.web3.currentProvider.isCipher)
    return "Cipher";
  if (environment.web3.currentProvider.constructor.name === "EthereumProvider")
    return "Mist";
  if (environment.web3.currentProvider.constructor.name === "Web3FrameProvider")
    return "Parity";
  if (environment.web3.currentProvider.host && environment.web3.currentProvider.host.indexOf("infura") !== -1)
    return "Infura";
  if (environment.web3.currentProvider.host && environment.web3.currentProvider.host.indexOf("localhost") !== -1)
    return "localhost";
  return "UnknownProvider";
}
function getWeb3Provider(url) {
  return url;
}

// src/locksmithService.ts
import fetch, { Headers } from "cross-fetch";
import { SiweMessage } from "siwe";
var PRODUCTION_HOST = "https://locksmith.unlock-protocol.com";
var LocksmithService = class {
  constructor(options) {
    this.baseURL = options.host || PRODUCTION_HOST;
  }
  static createSiweMessage(options) {
    return new SiweMessage(options);
  }
  getEndpoint(path) {
    return new URL(path, this.baseURL).toString();
  }
  async request(path, init) {
    const endpoint = path.startsWith("/") ? this.getEndpoint(path) : path;
    const response = await fetch(endpoint, init);
    if (!response.ok) {
      throw new FetchError({
        message: response.statusText,
        response,
        data: {
          message: await response.text()
        }
      });
    }
    return response;
  }
  async login(message, signature) {
    const headers = new Headers();
    headers.set("content-type", "application/json");
    const response = await this.request("/v2/auth/login", {
      method: "POST",
      headers,
      body: JSON.stringify({
        message,
        signature
      })
    });
    const json = await response.json();
    return {
      accessToken: json.accessToken,
      refreshToken: json.refreshToken
    };
  }
  async refreshToken(token) {
    const headers = new Headers();
    headers.set("content-type", "application/json");
    headers.set("refresh-token", token);
    const response = await this.request("/v2/auth/token", {
      method: "POST",
      headers
    });
    const json = await response.json();
    return {
      walletAddress: json.walletAddress,
      accessToken: json.accessToken
    };
  }
};

// src/index.ts
var latestUnlock = "v11";
var latestPublicLock = "v9";
export {
  LocksmithService,
  WalletService,
  Web3Service,
  getCurrentProvider,
  getWeb3Provider,
  latestPublicLock,
  latestUnlock
};
